import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import WifiProtectedSetupIcon from "@mui/icons-material/WifiProtectedSetup";
import {
  Box,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  addBillingItemsByPaymentId,
  applyTotalDiscountByPayAndDetailId,
  checkoutDirectBilling,
  deleteBillingPaymentById,
  deletePaymentItemById,
  getAllDiscountCodes,
  getBillDetailsByPaymentId,
  getClinicStocksWoLoader,
  getLocations,
  getServicesWoLoader,
  payAmountByPaymentId,
  setBillDetails,
  updateBillingByPaymentId,
  updateBillingItemsByPaymentId,
  updateClinicUserById,
  updateDiscountCodeById,
  updatePaymentTypeById,
} from "../../../redux/reducers/clinicSlice";
import { updateMultiCollectionStatusAndInvoiceNo } from "../../../redux/reducers/paymentSlice";
import { getClinicVetsWithFilter } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import {
  dropDiscountTypes,
  radioDiscountTypes,
  rolesForBilling,
} from "../../../util/arrayList";
import {
  delBtn,
  w15h15BlueIcon,
  w20h20BlueIcon,
  w20h20GreenIcon,
} from "../../../util/CommonIconStyle";
import { billAsForBillingHistory, discountTypes } from "../../../util/dropList";
import { billingTabEnum, payTabEnum } from "../../../util/enum";
import {
  getDiscountCodeAvailableToday,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getPrevDiscountValues,
  getRightPackageUom,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
  roundWithSignedDiff,
} from "../../../util/function";
import { tblGrayBack } from "../../../util/object";
import CommonPayModal from "../../CommonComponents/CommonPayModal";
import BillingPreview from "../../CommonScreens/BillingPreview/BillingPreview";
import CollectDeposit from "../../CommonScreens/Payments/CollectDeposit";

const phrTblHdrs = [
  "serviceitemname",
  "qty",
  "unitPrice",
  "discount",
  "tax",
  "total",
  "pay",
];
const tableNameExpan = {
  serviceitemname: "Service/Item Name",
  qty: "Qty",
  unitPrice: "Unit Price",
  tax: "Tax",
  adminCharge: "Admin Charge",
  total: "Item Total",
  days: "Days",
  discount: "Unit Discount",
};
const initialValues = {
  quantity: 1,
  price: 0,
  unitType: "Unit",
  discountType: discountTypes?.[0],
  linkToProcedure: null,
};
const initDis = { type: "code", amt: "", discountCode: null };
const initBilledBy = {
  billedBy: null,
  error: false,
  pharmacyBilledBy: null,
  pharmacyError: false,
  petShopBilledBy: null,
  petShopError: false,
  vet: null,
  vetError: false,
};

const PointOfSaleNew = ({
  selectedPayment,
  setSelecetdPayment,
  setActiveTab,
}) => {
  const dispatch = useDispatch();
  const [prntPrevVsble, setPrntPrevVsble] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemValues, setItemValues] = useState(initialValues);
  const [delModVisible, setDelModVisible] = useState(false);
  const [genBillModVsble, setGenBillModVsble] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [editModVsble, setEditModVsble] = useState(false);
  const [depositVsble, setDepositVsble] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchVisible, setSearchVisible] = useState(false);
  const [disModVsble, setDisModVsble] = useState(false);
  const [payModalVisible, setPayModalVisible] = useState(false);
  const [disValues, setDisValues] = useState(initDis);
  const [disErrs, setDisErrs] = useState({});
  const [switchValues, setSwitchValues] = useState({ visible: false });
  const [billedByValues, setBilledByValues] = useState(initBilledBy);
  const {
    services,
    billDetails,
    discountCodes,
    petBilling,
    locationList,
    facilities,
    selectedClinicBranch,
    clinicStocks: stocks,
    details: clinicData,
  } = useSelector((state) => state?.clinic);
  const vetList = useSelector((state) => state?.vet?.vetList?.vets);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const role = localStorage.getItem("role");
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    clinic: clinicDetails,
    vets: clinicVetList,
    dataSharing,
  } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinic: {}, vets: [], dataSharing: {} };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        dataSharing: reqData?.dataSharing ?? {},
      };
    } catch {
      return { clinic: {}, vets: [], dataSharing: {} };
    }
  }, [mandateDataRaw]);
  const clinicVets =
    role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
      ? (vetList ?? [])
      : (clinicVetList ?? []);
  const clinicDet = clinicDetails?.id ? clinicDetails : clinicData;
  const isBillCombined =
    (clinicDet?.billingMode ?? "")?.toLowerCase() === "combined";
  const treatTabList = getTreatmentRecordBasedType(
    billDetails?.paymentDetails ?? [],
    true,
    // isBillCombined,
  );
  const pharTabList = getPharmacyRecordBasedType(
    billDetails?.paymentDetails ?? [],
    true,
    // isBillCombined,
  );
  const petShopTabList = getPetShopRecordBasedType(
    billDetails?.paymentDetails ?? [],
    true,
    // isBillCombined,
  );

  useEffect(() => {
    if (selectedPayment?.paymentId) {
      dispatch(getBillDetailsByPaymentId(selectedPayment?.paymentId)).then(
        (res) => {
          if (res?.payload) {
            const url =
              role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
                ? `?clinicId=${selectedClinicBranch?.branchId}`
                : "";
            dispatch(getClinicStocksWoLoader(url));
            dispatch(getServicesWoLoader(url));
            // getProductAndServiceListForDropdown(url);
            dispatch(getLocations(url));
            // dispatch(getClinicFacilities(url));
            if (role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId) {
              dispatch(
                getClinicVetsWithFilter({
                  type: ["doctor"],
                  vetData: dataSharing?.vetData,
                }),
              );
            }
            getDiscountCodeList(url);
          }
        },
      );
    }
    return () => {
      dispatch(setBillDetails(null));
    };
  }, []);

  useEffect(() => {
    if (
      (billDetails?.type === "Clinic" ||
        billDetails?.type === "Treatment" ||
        billDetails?.type === "Pharmacy" ||
        billDetails?.type === "Pet Shop") &&
      ((billDetails?.checkOut !== "P" && billDetails?.checkOut !== "Y") ||
        billDetails?.pharmacyCheckout !== "Y" ||
        billDetails?.pharmacyCheckout !== "Y")
    ) {
      const reqObj = {
        billedBy: {
          name: billDetails?.billedByName ?? profile?.name,
          value: billDetails?.billedById ?? profile?.id,
        },
        error: false,
        pharmacyBilledBy: {
          name: billDetails?.pharmacyBilledByName ?? profile?.name,
          value: billDetails?.pharmacyBilledById ?? profile?.id,
        },
        pharmacyError: false,
        petShopBilledBy: {
          name: billDetails?.petShopBilledByName ?? profile?.name,
          value: billDetails?.petShopBilledById ?? profile?.id,
        },
        petShopError: false,
        vet: null,
        vetError: false,
      };
      if (billDetails?.doctorId) {
        reqObj.vet = {
          name: billDetails?.doctorName,
          value: billDetails?.doctorId,
        };
      }
      setBilledByValues(reqObj);
    }
  }, [billDetails]);

  // const getProductAndServiceListForDropdown = (url) => {
  //   let reqServices = [];
  //   dispatch(getServicesWoLoader(url)).then((res) => {
  //     if (res?.payload?.data?.length > 0) {
  //       reqServices = res?.payload?.data?.map((ser) => {
  //         return {
  //           ...ser,
  //           name: ser?.serviceName,
  //           value: ser?.serviceId,
  //           type: "Service",
  //         };
  //       });
  //     }
  //     setServiceList(reqServices);
  //   });
  // };

  const getTabBasedRecords = () => {
    return billDetails?.type === "Clinic"
      ? getTreatmentRecordBasedType(billDetails?.paymentDetails, true)
      : billDetails?.type === "Pet Shop"
        ? getPetShopRecordBasedType(billDetails?.paymentDetails, true)
        : getPharmacyRecordBasedType(billDetails?.paymentDetails, true);
  };

  const getDiscountCodeList = (url = "") => {
    dispatch(getAllDiscountCodes(url));
  };

  const handleDelete = (bill) => {
    setSelectedItem(bill);
    setDelModVisible(true);
  };

  const handleEdit = (bill) => {
    const reqStck = stocks?.data?.find((stc) => stc?.stockId === bill?.stockId);
    const reqBat = reqStck?.stockBatch?.find(
      (btch) => btch?.batchId === bill?.batchId,
    );
    // const reqUOm = reqBat?.packageUom?.match(/^(\d+)(.+)/);
    const reqUnitPrice = Number(
      Number(bill?.price ?? 0),
      // /
      //   Number(
      //     bill?.type?.toLowerCase() === "administered"
      //       ? Number(reqUOm?.[1] ?? 1)
      //       : 1,
      //   ),
    );
    const reqObj = {
      ...itemValues,
      ...bill,
      name: bill?.name,
      quantity: bill?.quantity,
      price: Number(bill?.mrpPrice ?? bill?.price)?.toFixed(2),
      tax: bill?.tax,
      serviceId: bill?.serviceId ?? null,
      productId: bill?.productId ?? null,
      unitType: bill?.subUnit ?? "Unit",
      adminCharge: "N",
      adminChargeAmount: 0,
      paymentDetailId: bill?.paymentDetailId,
      discount: bill?.mrpDiscount ?? bill?.discount,
      discountType:
        bill?.discountType === "pe" ? discountTypes?.[0] : discountTypes?.[1],
      stockId: bill?.stockId,
      batchId: bill?.batchId,
      batchNumber: reqBat
        ? {
            name: reqBat?.batchNo,
            value: reqBat?.batchId,
            batchId: reqBat?.batchId,
          }
        : null,
      variantNumber: bill?.variantNumber,
      variantId: bill?.variantId,
      type: bill?.type,
      hsnSacCode: bill?.hsnSacCode ?? null,
      drugSchedule: bill?.drugSchedule ?? null,
      packageUom: bill?.packageUom ?? null,
      expiryDate: bill?.expiryDate ?? null,
      batchNo: bill?.batchNo ?? null,
      autoConsumed: false,
      // reqStck?.autoConsumed ?? false,
    };
    // if (bill?.discountType === "pe") {
    //   const reqPercent = (Number(bill?.discount) / Number(bill?.price)) * 100;
    //   reqObj.discount = reqPercent;
    // }
    if (bill?.discountType) {
      reqObj.discountType =
        bill?.discountType === "pe"
          ? dropDiscountTypes?.[1]
          : dropDiscountTypes?.[2];
      if (bill?.discountType === "pe") {
        const reqPercent =
          (Number(bill?.mrpDiscount ?? bill?.discount) / Number(reqUnitPrice)) *
          100;
        reqObj.discountValue = Number(reqPercent)?.toFixed(2);
      } else {
        reqObj.discountValue =
          (bill?.mrpDiscount ?? bill?.discount)
            ? Number(bill?.mrpDiscount ?? bill?.discount)?.toFixed(2)
            : 0;
      }
    } else {
      reqObj.discountType = dropDiscountTypes?.[2];
      // const reqPercent =
      //   Number(
      //     Number(bill?.mrpDiscount ?? bill?.discount ?? 0) /
      //       Number(bill?.price ?? 0)
      //   ) * 100;
      reqObj.discountValue = 0;
      // isNaN(reqPercent) ? 0 : reqPercent;
    }
    setItemValues(reqObj);
    setSelectedItem(bill);
    setEditModVsble(true);
  };

  const getUsedDiscountCodes = () => {
    if (billDetails?.type === "Pharmacy") {
      if (billDetails?.pharmacyDiscountId?.length > 0) {
        const reqList = billDetails?.pharmacyDiscountId
          ?.map((li) => {
            const match = discountCodes?.find(
              (dc) => dc?.billId?.toString() === li,
            );
            return match;
          })
          ?.filter(Boolean); // remove undefined if no match found
        return reqList;
      }
      return [];
    }
    if (billDetails?.type === "Pet Shop") {
      if (billDetails?.petShopDiscountId?.length > 0) {
        const reqList = billDetails?.petShopDiscountId
          ?.map((li) => {
            const match = discountCodes?.find(
              (dc) => dc?.billId?.toString() === li,
            );
            return match;
          })
          ?.filter(Boolean); // remove undefined if no match found
        return reqList;
      }
      return [];
    }
  };

  const handleUpdatePaymentValues = async () => {
    dispatch(
      getBillDetailsByPaymentId(
        billDetails?.paymentId ?? selectedPayment?.paymentId,
      ),
    ).then(async (res) => {
      const pay = res?.payload;
      // const treatRecords = getTreatmentRecordBasedType(
      //   pay?.paymentDetails ?? [],
      // );
      // const pharRecords = getPharmacyRecordBasedType(pay?.paymentDetails ?? []);
      // const petShopList = getPetShopRecordBasedType(pay?.paymentDetails ?? []);
      const getTotalValues = getTaxAndSubTotalAndTotal(
        pay?.paymentDetails ?? [],
        // pay?.type === "Pet Shop" || billDetails?.type === "Pet Shop"
        //   ? (petShopList ?? [])
        //   : (pharRecords ?? []),
      );
      const subTotal =
        roundWithSignedDiff(getTotalValues?.subTotal)?.rounded ?? 0;
      const tax = getTotalValues?.tax ?? 0;
      const discount = getTotalValues?.discount ?? 0;

      // const treatRecCount = treatRecords?.length ?? 0;
      // const pharRecCount = pharRecords?.length ?? 0;
      // const petShopRecCount = petShopList?.length ?? 0;

      // const config = {
      //   Treatment: {
      //     count: treatRecCount,
      //     key: "treatmentCheckout",
      //     value: pay?.checkOut,
      //     emptyVal: "Y",
      //     doneVal: "N",
      //   },
      //   Pharmacy: {
      //     count: pharRecCount,
      //     key: "pharmacyCheckout",
      //     value: pay?.pharmacyCheckout,
      //     emptyVal: "Y",
      //     doneVal: "N",
      //   },
      //   "Pet Shop": {
      //     count: petShopRecCount,
      //     key: "petShopCheckout",
      //     value: pay?.petShopCheckout,
      //     emptyVal: "Y",
      //     doneVal: "N",
      //   },
      // };
      // const tab = config[billDetails?.type];
      // let url = "";
      // if (tab) {
      //   if (tab.count === 0) {
      //     url = `?treatmentCheckout=Y&pharmacyCheckout=Y&petShopCheckout=Y`;
      //     // url = `?${tab.key}=${tab.emptyVal}${
      //     //   billDetails?.type !== "Treatment" ? `&treatmentCheckout=Y` : ""
      //     // }`;
      //   }
      //   if (tab.value === "Y") {
      //     url = `?treatmentCheckout=N&pharmacyCheckout=N&petShopCheckout=N`;
      //     // url = `?${tab.key}=${tab.doneVal}${
      //     //   billDetails?.type !== "Treatment" ? `&treatmentCheckout=N` : ""
      //     // }`;
      //   }
      // }

      // if (url) {
      //   dispatch(
      //     checkoutDirectBilling({
      //       paymentId: billDetails?.paymentId ?? selectedPayment?.paymentId,
      //       url,
      //     }),
      //   );
      // }

      const reqData = {
        paymentId: billDetails?.paymentId ?? selectedPayment?.paymentId,
        data: {
          totalAmt: Number(subTotal ?? 0),
          amtPaid:
            billDetails?.type === "Pet Shop"
              ? Number(pay?.petShopAmtPaid ?? 0)
              : Number(pay?.pharmacyAmtPaid ?? 0),
          discount: Number(discount ?? 0),
          tax: Number(tax ?? 0),
          tabName: billDetails?.type === "Pet Shop" ? "petShop" : "pharmacy",
        },
      };

      dispatch(updateBillingByPaymentId(reqData))?.then((apiRes) => {
        if (apiRes?.payload) {
          dispatch(
            getBillDetailsByPaymentId(
              billDetails?.paymentId ?? selectedPayment?.paymentId,
            ),
          );
        }
      });
    });
  };

  const applyPriceDiscountToItems = (
    item = null,
    reqDiscountValue = 0,
    isUpdateItem = false,
  ) => {
    let reqArray = getTabBasedRecords() ?? [];
    if (!isUpdateItem) {
      reqArray.push({
        ...item,
        tax: 0,
        total:
          item?.servicePrice ??
          item?.unitSellingPrice ??
          item?.stockBatch?.[0]?.unitSellingPrice ??
          0,
        discount: 0,
        adminCharge: 0,
        quantity: 1,
        subTotal:
          item?.servicePrice ??
          item?.unitSellingPrice ??
          item?.stockBatch?.[0]?.unitSellingPrice ??
          0,
      });
    }
    if (isUpdateItem) {
      reqArray = reqArray?.map((li) => {
        if (li?.paymentDetailId === item?.paymentDetailId) {
          return {
            ...li,
            ...item,
            quantity: Number(itemValues?.quantity ?? 1),
            subTotal:
              Number(item?.mrpPrice ?? 0) * Number(itemValues?.quantity ?? 1),
            total:
              Number(item?.mrpPrice ?? 0) * Number(itemValues?.quantity ?? 1),
            discount: 0,
          };
        }
        return {
          ...li,
          subTotal: Number(li?.mrpPrice ?? 0) * Number(li?.quantity ?? 1),
          total: Number(li?.mrpPrice ?? 0) * Number(li?.quantity ?? 1),
          discount: 0,
        };
      });
    }
    const totalDet = getTaxAndSubTotalAndTotal(reqArray);

    const applyDiscount = reqArray?.map((li) => {
      const reqObj = {
        paymentDetailsId: li?.paymentDetailId ?? null,
        discount: 0,
        percentage: "pr",
        price: 0,
        mrpPrice: 0,
        mrpDiscount: 0,
        tax: 0,
        total: 0,
        quantity: li?.quantity,
      };
      const reqStck = stocks?.data?.find((stc) => stc?.stockId === li?.stockId);
      const reqBat = reqStck?.stockBatch?.find(
        (btch) => btch?.batchId === li?.batchId,
      );
      if (reqBat) {
        if (billDetails?.type === "Pharmacy") {
          const taxPerent =
            Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
          // clinicDet?.pharmacyTaxId?.length > 0
          //   ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
          //   : 0;
          const reqPercent = 100 + Number(taxPerent);
          const unitPrice =
            Number(reqBat?.unitSellingPrice) / (reqPercent / 100);
          const discount = Number(
            Number(
              Number(
                Number(unitPrice) /
                  Number(
                    totalDet?.subTotal - totalDet?.tax + totalDet?.discount,
                  ),
              ) * Number(reqDiscountValue ?? 0),
            ),
          );
          const priceAfterDiscount = Number(unitPrice) - Number(discount);
          const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
          reqObj.price = unitPrice;
          reqObj.discount = discount;
          reqObj.tax = Number(taxValue ?? 0) * Number(li?.quantity);
          reqObj.total =
            Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
            Number(li?.quantity);
          reqObj.mrpPrice = Number(reqBat?.unitSellingPrice);
          reqObj.mrpDiscount = discount;
        }
      }
      if (li?.serviceId) {
        const unitPrice =
          (li?.variantId
            ? services?.data
                ?.find((ser) => ser?.serviceId === li?.serviceId)
                ?.serviceVariants?.find((sv) => sv?.variantId === li?.variantId)
            : services?.data?.find((ser) => ser?.serviceId === li?.serviceId)
          )?.servicePrice ??
          item?.servicePrice ??
          0;

        const discount = Number(
          Number(
            Number(
              Number(unitPrice) /
                Number(totalDet?.subTotal - totalDet?.tax + totalDet?.discount),
            ) * Number(reqDiscountValue ?? 0),
          ),
        );
        reqObj.price = Number(unitPrice ?? 0);
        reqObj.discount = discount;
        reqObj.total =
          (Number(unitPrice ?? 0) - Number(discount ?? 0)) *
          Number(li?.quantity);
        reqObj.mrpPrice = Number(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      if (!li?.serviceId && !li?.stockId) {
        const unitPrice = li?.price;
        const discount = Number(
          Number(
            Number(
              Number(
                Number(unitPrice) /
                  Number(
                    totalDet?.subTotal - totalDet?.tax + totalDet?.discount,
                  ),
              ) * Number(reqDiscountValue ?? 0),
            ),
          ),
        );
        reqObj.price = Number(unitPrice ?? 0);
        reqObj.tax = 0;
        reqObj.discount = discount;
        reqObj.total =
          (Number(unitPrice ?? 0) - Number(discount ?? 0)) *
          Number(li?.quantity);
        reqObj.mrpPrice = Number(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      return reqObj;
    });

    const getNewObj = applyDiscount?.find(
      (li) =>
        !li?.paymentDetailsId || li?.paymentDetailsId === item?.paymentDetailId,
    );
    const paymentServiceRequest = {
      paymentDetailId: item?.paymentDetailId ?? null,
      billType: "prescribed",
      adminCharge: "N",
      adminChargeAmount: 0,
      name: item?.name ?? searchValue,
      quantity: Number(itemValues?.quantity ?? 1),
      type: item ? (item?.serviceId ? "service" : "product") : "service",
      discount: getNewObj?.discount ?? 0,
      mrpDiscount: getNewObj?.mrpDiscount ?? 0,
      percentage: false,
      subUnit: "Unit",
      price: getNewObj?.price ?? 0,
      mrpPrice: getNewObj?.mrpPrice ?? 0,
      tax: getNewObj?.tax ?? 0,
      discountType: "pr",
      total: getNewObj?.total ?? 0,
    };
    if (item?.productId) paymentServiceRequest.productId = item?.productId;
    if (item?.serviceId) paymentServiceRequest.serviceId = item?.serviceId;
    if (item?.variantNumber)
      paymentServiceRequest.variantNumber = item?.variantNumber;
    if (item?.variantId) paymentServiceRequest.variantId = item?.variantId;
    const data = {
      applyDiscount: applyDiscount?.filter((li) => li?.paymentDetailsId),
      treatmentDiscountType: "pr",
      treatmentDiscountValue: billDetails?.treatmentDiscountValue ?? 0,
      treatmentDiscountId: billDetails?.treatmentDiscountId ?? [],
      pharmacyDiscountType: "pr",
      pharmacyDiscountValue:
        billDetails?.type === "Pharmacy"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.pharmacyDiscountValue ?? 0),
      pharmacyDiscountId: billDetails?.pharmacyDiscountId ?? [],
      petShopDiscountType: "pr",
      petShopDiscountValue:
        billDetails?.type === "Pet Shop"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.petShopDiscountValue ?? 0),
      petShopDiscountId: billDetails?.petShopDiscountId ?? [],
    };
    if (!isUpdateItem) data.paymentServiceRequest = paymentServiceRequest;
    dispatch(
      applyTotalDiscountByPayAndDetailId({
        paymentId: billDetails?.paymentId ?? selectedPayment?.paymentId,
        data,
      }),
    ).then((res) => {
      if (res?.payload) {
        setSelectedItem(null);
        setEditVisible(false);
        setSearchValue("");
        setSearchVisible(false);
        dispatch(
          getBillDetailsByPaymentId(
            billDetails?.paymentId ?? selectedPayment?.paymentId,
          ),
        );
      }
    });
  };

  const handleAddItem = async (item) => {
    const prevDiscountList = getUsedDiscountCodes();
    let discountType = "percentage",
      discountValue = 0;
    if (prevDiscountList?.length > 0) {
      const reqObj = getPrevDiscountValues(prevDiscountList);
      if (reqObj?.percentage > 0) {
        discountType = "percentage";
        discountValue = reqObj?.percentage;
      }
      if (reqObj?.price > 0) {
        discountType = "price";
        discountValue = reqObj?.price;
      }
    }
    if (
      discountType?.toLowerCase() !== "percentage" &&
      getTabBasedRecords()?.length > 0
    ) {
      return applyPriceDiscountToItems(item, discountValue);
    }
    const reqObj = {
      billType: billingTabEnum?.[billDetails?.type],
      adminCharge: "N",
      adminChargeAmount: 0,
      name: item?.name ?? searchValue,
      quantity: 1,
      type: item ? (item?.serviceId ? "service" : "product") : "service",
      discount: 0,
      percentage: false,
      subUnit: "Unit",
      patientWorkbook: false,
      tabName: billDetails?.type === "Pet Shop" ? "petShop" : "pharmacy",
      autoConsumed: false,
    };
    if (item?.serviceId) {
      let serviceTax = 0,
        serviceTotal = 0,
        subItemTax = 0;
      const reqService = services?.data?.find(
        (ser) => ser?.serviceId === item?.serviceId,
      );
      const reqVariant = reqService?.serviceVariants?.find(
        (vnt) => vnt?.variantId === item?.variantId,
      );
      serviceTotal += Number(reqVariant?.serviceCharge ?? 0);
      if (reqService?.taxApplicability?.toLowerCase() === "yes") {
        serviceTax +=
          reqService?.taxApplicability?.toLowerCase() === "yes"
            ? (Number(reqVariant?.serviceCharge ?? 0) / 100) *
              Number(reqService?.tax ?? 0)
            : 0;
      }
      const reqDiscount =
        discountType?.toLowerCase() !== "percentage"
          ? Number(discountValue ?? 0)
          : (Number(
              Number(Number(item?.servicePrice ?? 0) / 100) *
                Number(discountValue ?? 0),
            ) ?? 0);
      reqObj.serviceId = item?.serviceId;
      reqObj.variantId = item?.variantId;
      reqObj.variantNumber = item?.variantNumber;
      reqObj.price = Number(reqVariant?.serviceCharge ?? 0);
      reqObj.mrpPrice = Number(reqVariant?.serviceCharge ?? 0);
      reqObj.discountType =
        discountType?.toLowerCase() === "percentage" ? "pe" : "pr";
      reqObj.discount = reqDiscount;
      reqObj.mrpDiscount =
        discountType?.toLowerCase() !== "percentage"
          ? (Number(itemValues?.servicePrice ?? 0) / 100) *
            Number(reqDiscount ?? 0)
          : Number(reqDiscount ?? 0);
      reqObj.tax = Number(serviceTax) + Number(subItemTax);
      reqObj.total = Number(serviceTotal ?? 0) + Number(serviceTax ?? 0);
      reqObj.hsnSacCode = item?.hsnSacCode ?? null;
    }
    if (item?.stockId) {
      const reqBat = item?.stockBatch?.[0];
      reqObj.stockId = item?.stockId;
      // reqObj.autoConsumed = item?.autoConsumed ?? false;
      if (reqBat) {
        reqObj.batchId = reqBat?.batchId;
        const reqDiscount =
          discountType?.toLowerCase() !== "percentage"
            ? Number(discountValue ?? 0)
            : (Number(
                Number(Number(reqBat?.unitSellingPrice ?? 0) / 100) *
                  Number(discountValue ?? 0),
              ) ?? 0);
        const taxPerent = Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
        // (billDetails?.type === "Pharmacy"
        //   ? clinicDet?.pharmacyTaxId
        //   : clinicDet?.petShopTaxId
        // )?.length > 0
        //   ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
        //   : 0;
        const reqPercent = 100 + Number(taxPerent);
        const reqPrice = Number(reqBat?.unitSellingPrice) ?? 0;
        const reqUnitPrice = reqBat?.unitSellingPrice;
        const unitPrice = Number(reqUnitPrice) / (reqPercent / 100);
        const priceAfterDiscount = Number(unitPrice) - Number(reqDiscount);
        const prdTaxValue = (taxPerent / 100) * Number(unitPrice);
        reqObj.price = unitPrice;
        // item?.autoConsumed ? 0 : unitPrice;
        reqObj.discount = reqDiscount;
        // item?.autoConsumed ? 0 : reqDiscount;
        reqObj.tax = Number(prdTaxValue);
        //  item?.autoConsumed ? 0 : Number(prdTaxValue);
        reqObj.total = Number(
          Number(priceAfterDiscount ?? 0) + Number(prdTaxValue ?? 0),
        );
        //  item?.autoConsumed
        //   ? 0
        //   : Number(Number(priceAfterDiscount ?? 0) + Number(prdTaxValue ?? 0));
        reqObj.mrpPrice = Number(reqBat?.unitSellingPrice);
        //  item?.autoConsumed
        //   ? 0
        //   : Number(reqBat?.unitSellingPrice);
        reqObj.mrpDiscount =
          discountType?.toLowerCase() === "percentage"
            ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
            : Number(discountValue ?? 0);
        //  item?.autoConsumed
        //   ? 0
        //   : discountType?.toLowerCase() === "percentage"
        //     ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
        //     : Number(discountValue ?? 0);
        reqObj.hsnSacCode = item?.hsnSacCode ?? null;
        reqObj.drugSchedule = item?.drugSchedule ?? null;
        reqObj.packageUom = reqBat?.salesUom ?? null;
        reqObj.expiryDate = reqBat?.expiryDate ?? null;
        reqObj.batchNo = reqBat?.batchNo ?? null;
      }
    }
    if (!item) {
      reqObj.price = 0;
      reqObj.tax = 0;
      reqObj.total = 0;
    }
    const reqData = {
      paymentId: billDetails?.paymentId ?? selectedPayment?.paymentId,
      data: reqObj,
    };
    dispatch(addBillingItemsByPaymentId(reqData))?.then((res) => {
      if (res?.payload) {
        handleUpdatePaymentValues();
        setSearchValue("");
        setSearchVisible(false);
      }
    });
  };

  const getIsLocationMatch = (batchList = [], category = "pharmacy") => {
    const result = batchList?.some((bat) => {
      if (!bat?.locationId) return false;
      const loc = locationList?.find((loc) => loc?.id === bat?.locationId);
      return loc && loc?.category?.toLowerCase() === category;
    });
    return result;
  };

  const getFilteredList = () => {
    if (!searchVisible || !searchValue?.length) return [];
    const searchLower = searchValue?.toLowerCase();
    const reqPrdList =
      stocks?.data?.map((li) => {
        const allQty = li?.stockBatch?.reduce((acc, obj) => {
          return acc + Number(obj?.quantity ?? 0);
        }, 0);
        return {
          ...li,
          name: li?.tradeName ?? li?.productName,
          type: "Product",
          availableQty: allQty > 0 ? allQty : "-",
          stockBatch: (li?.stockBatch ?? [])
            ?.filter((item) => (item?.quantity ?? 0) >= 1)
            ?.sort((a, b) => a?.quantity - b?.quantity),
        };
      }) ?? [];
    let reqList = reqPrdList;
    if (billDetails?.type === "Clinic") {
      const reqServList = [];
      (services?.data ?? [])?.forEach((ser) => {
        if (ser?.serviceVariants?.length > 0) {
          ser.serviceVariants.forEach((vrnt) => {
            reqServList.push({
              name: `${ser?.serviceName} (${vrnt?.variantName})`,
              variantId: vrnt?.variantId,
              variantNumber: vrnt?.variantNumber,
              type: "Service",
              category: ser?.category,
              servicePrice: vrnt?.servicePrice ?? 0,
              serviceId: ser?.serviceId,
              hsnSacCode: ser?.hsnSacCode ?? null,
              availableQty: "-",
            });
          });
        } else {
          reqServList.push(ser);
        }
      });
      reqList = [...reqServList, ...reqPrdList];
    }

    const matchesStockLocationRules = (sp) => {
      if (!sp?.stockId || sp?.active !== "Y" || !sp?.billable) return false;
      if (isBillCombined) return true;
      const reqCat =
        isBillCombined || billDetails?.type === "Clinic"
          ? "clinic"
          : billDetails?.type === "Pharmacy"
            ? "pharmacy"
            : "pet shop";
      return getIsLocationMatch(sp?.stockBatch, reqCat);
    };

    const matchesSearchText = (sp) =>
      (sp?.name ?? "")?.toLowerCase().includes(searchLower) ||
      (sp?.tradeName ?? "")?.toLowerCase().includes(searchLower) ||
      (sp?.productName ?? "")?.toLowerCase().includes(searchLower) ||
      (sp?.skuId ?? "")?.toLowerCase().includes(searchLower) ||
      (sp?.barcodeNo ?? "")?.toLowerCase().includes(searchLower);

    return reqList?.filter(
      (sp) =>
        (sp?.serviceId ? true : matchesStockLocationRules(sp)) &&
        matchesSearchText(sp),
    );
  };

  // const getFilteredList = () => {
  //   if (!searchVisible || searchValue?.length === 0) return [];
  //   if (searchValue?.length > 0) {
  //     const reqPrdList = stocks?.data?.map((li) => ({
  //       ...li,
  //       name: li?.productName,
  //       type: "Product",
  //     }));
  //     let reqList = reqPrdList ?? [];
  //     const filList = reqList?.filter((sp) =>
  //       sp?.stockId
  //         ? sp?.active === "Y" &&
  //           sp?.billable &&
  //           (billDetails?.type === "Pharmacy"
  //             ? getIsLocationMatch(sp?.stockBatch, "pharmacy")
  //             : billDetails?.type === "Pet Shop"
  //               ? getIsLocationMatch(sp?.stockBatch, "pet shop")
  //               : []) &&
  //           (sp?.name?.toLowerCase().includes(searchValue?.toLowerCase()) ||
  //             sp?.tradeName
  //               ?.toLowerCase()
  //               .includes(searchValue?.toLowerCase()) ||
  //             sp?.productName
  //               ?.toLowerCase()
  //               .includes(searchValue?.toLowerCase()))
  //         : false,
  //     );

  //     return filList;
  //   }
  // };

  const handleApplyDiscount = () => {
    const reqObj = { ...disValues };
    if (billDetails?.type === "Pharmacy") {
      reqObj.type =
        Number(billDetails?.pharmacyDiscountValue ?? 0) > 0
          ? billDetails?.pharmacyDiscountType === "pe"
            ? "percentage"
            : "price"
          : "code";
      reqObj.amt = billDetails?.pharmacyDiscountValue ?? 0;
      reqObj.discountCode = null;
    }
    if (billDetails?.type === "Pet Shop") {
      reqObj.type =
        Number(billDetails?.petShopDiscountValue ?? 0) > 0
          ? billDetails?.petShopDiscountType === "pe"
            ? "percentage"
            : "price"
          : "code";
      reqObj.amt = billDetails?.petShopDiscountValue ?? 0;
      reqObj.discountCode = null;
    }
    setDisValues(reqObj);
    setDisModVsble(true);
  };

  const handleDelConfirm = () => {
    if (selectedItem?.paymentDetailId) {
      dispatch(deletePaymentItemById(selectedItem?.paymentDetailId)).then(
        (res) => {
          if (res?.payload) {
            handleUpdatePaymentValues();
            setSelectedItem(null);
            setDelModVisible(false);
          }
        },
      );
    } else {
      dispatch(
        deleteBillingPaymentById(
          billDetails?.paymentId ?? selectedPayment?.paymentId,
        ),
      ).then((res) => {
        if (res?.payload) {
          setDelModVisible(false);
          setActiveTab("Dashboard");
          setSelecetdPayment(null);
        }
      });
    }
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setSelectedItem(null);
  };

  const onSaveAsDraft = () => {
    setActiveTab("Dashboard");
    setSelecetdPayment(null);
  };

  const onCloseEditMod = () => {
    setEditModVsble(false);
    setItemValues(null);
    setSelectedItem(null);
  };

  const handleUpdateItem = async (item) => {
    if (getTaxDiscountAndTotal(itemValues)?.isHigherDiscount) return;
    // const prevDiscountList = getUsedDiscountCodes();
    let discountType = "percentage",
      discountValue = 0;
    if (typeof item?.discountValue === "object") {
      discountType = item?.discountValue?.discountType?.toLowerCase();
      discountValue = item?.discountValue?.discountValue;
    }
    if (typeof item?.discountValue !== "object") {
      discountType = item?.discountType?.value?.toLowerCase();
      discountValue = item?.discountValue;
    }
    const reqStck = stocks?.data?.find(
      (stc) => stc?.stockId === (itemValues?.stockId ?? item?.stockId),
    );
    const reqBat = reqStck?.stockBatch?.find(
      (btch) =>
        btch?.batchId ===
        (item?.batchNumber?.batchId ??
          item?.batchNumber?.value ??
          item?.batchId),
    );
    let discount =
      discountType?.toLowerCase() !== "percentage"
        ? Number(discountValue ?? 0)
        : (Number(
            Number(Number(itemValues?.price ?? 0) / 100) *
              Number(discountValue ?? 0),
          ) ?? 0);
    const reqObj = {
      paymentDetaisId: selectedItem?.paymentDetailId ?? item?.paymentDetailId,
      tax: 0,
      adminCharge: "N",
      adminChargeAmount: 0,
      quantity: Number(itemValues?.quantity),
      type: selectedItem?.type ?? item?.type,
      percentage: discountType?.toLowerCase() === "percentage",
      stockId: itemValues?.stockId,
      batchId:
        item?.batchNumber?.batchId ?? item?.batchNumber?.value ?? item?.batchId,
      name: itemValues?.name,
      billType: billingTabEnum?.[billDetails?.type],
      serviceId: item?.serviceId,
      patientWorkbook: item?.patientWorkbook ?? false,
      total: Number(item?.total ?? 0),
      mrpPrice: Number(itemValues?.mrpPrice ?? 0),
      tabName: billDetails?.type === "Pet Shop" ? "petShop" : "pharmacy",
      autoConsumed: item?.autoConsumed ?? false,
    };
    if (reqBat) {
      const taxPerent = Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
      // (billDetails?.type === "Treatment"
      //   ? clinicDet?.taxId
      //   : clinicDet?.petShopTaxId
      // )?.length > 0
      //   ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
      //   : 0;
      const reqPercent = 100 + Number(taxPerent);
      const reqPrice = Number(reqBat?.unitSellingPrice) ?? 0;
      const reqUnitPrice = reqBat?.unitSellingPrice;
      const unitPrice = Number(reqUnitPrice) / (reqPercent / 100);
      const reqDiscount =
        discountType?.toLowerCase() === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
      const priceAfterDiscount = Number(unitPrice) - Number(reqDiscount ?? 0);
      const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
      reqObj.price = item?.autoConsumed ? 0 : Number(reqBat?.unitSellingPrice);
      reqObj.discount = item?.autoConsumed ? 0 : Number(reqDiscount ?? 0);
      reqObj.tax = item?.autoConsumed
        ? 0
        : Number(taxValue ?? 0) * Number(itemValues?.quantity);
      reqObj.total = item?.autoConsumed
        ? 0
        : Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
          Number(itemValues?.quantity);
      reqObj.mrpPrice = item?.autoConsumed
        ? 0
        : Number(reqBat?.unitSellingPrice);
      reqObj.mrpDiscount = item?.autoConsumed ? 0 : Number(reqDiscount ?? 0);
      reqObj.hsnSacCode = itemValues?.hsnSacCode ?? null;
      reqObj.drugSchedule = itemValues?.drugSchedule ?? null;
      reqObj.packageUom = reqBat?.salesUom ?? null;
      reqObj.expiryDate = reqBat?.expiryDate ?? null;
      reqObj.batchNo = reqBat?.batchNo ?? null;
    }
    if (!item?.serviceId && !item?.stockId) {
      reqObj.price = Number(itemValues?.price ?? 0);
      reqObj.tax = 0;
      reqObj.discount = discount;
      reqObj.total =
        (Number(itemValues?.price ?? 0) - Number(discount ?? 0)) *
        Number(itemValues?.quantity);
      reqObj.mrpPrice = Number(itemValues?.price ?? 0);
      reqObj.mrpDiscount =
        discountType?.toLowerCase() === "percentage"
          ? (Number(itemValues?.price ?? 0) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
    }
    if (item?.serviceId) {
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === item?.serviceId,
      );
      const reqVar = reqServ?.serviceVariants?.find(
        (vnt) => vnt?.variantId === item?.variantId,
      );
      const unitPrice =
        Number(itemValues?.price ?? 0) ?? Number(reqVar?.serviceCharge ?? 0);
      const taxPerent =
        reqServ?.taxApplicability?.toLowerCase() === "yes"
          ? Number(reqServ?.tax ?? 0)
          : 0;
      const reqDiscount =
        discountType?.toLowerCase() === "percentage"
          ? (Number(unitPrice) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);
      const priceAfterDiscount = Number(unitPrice) - Number(reqDiscount ?? 0);
      const taxValue =
        (Number(priceAfterDiscount ?? 0) / 100) * Number(taxPerent ?? 0);
      const priceAfterTax = Number(priceAfterDiscount) + Number(taxValue);
      reqObj.price = unitPrice;
      reqObj.mrpPrice = unitPrice;
      reqObj.mrpDiscount = Number(reqDiscount ?? 0);
      reqObj.discount = Number(reqDiscount ?? 0);
      reqObj.variantId = itemValues?.variantId;
      reqObj.variantNumber = itemValues?.variantNumber;
      reqObj.tax = Number(taxValue ?? 0) * Number(itemValues?.quantity ?? 1);
      reqObj.total =
        Number(priceAfterTax ?? 0) * Number(itemValues?.quantity ?? 1);
      reqObj.hsnSacCode = itemValues?.hsnSacCode ?? null;
    }
    const reqData = {
      paymentId: billDetails?.paymentId ?? selectedPayment?.paymentId,
      data: reqObj,
    };
    dispatch(updateBillingItemsByPaymentId(reqData)).then((res) => {
      if (res?.payload) {
        handleUpdatePaymentValues();
        setSelectedItem(null);
        setEditVisible(false);
        setEditModVsble(false);
      }
    });
  };

  const getTaxDiscountAndTotal = (itm) => {
    let tax = 0,
      discount = 0,
      total = 0,
      price = 0,
      discountType = "percentage",
      discountValue = 0,
      quantity = Number(itm?.quantity ?? 1),
      isHigherDiscount = false;

    // Extract discount type and value
    if (typeof itm?.discountValue === "object") {
      discountType = itm?.discountValue?.discountType?.toLowerCase();
      discountValue = Number(itm?.discountValue?.discountValue ?? 0);
    } else {
      discountType = itm?.discountType?.value?.toLowerCase() || "percentage";
      discountValue = Number(itm?.discountValue ?? 0);
    }
    // Handle stock items (products)
    if (itm?.stockId) {
      const reqStockBatch = stocks?.data?.find(
        (stc) => stc?.stockId === itm?.stockId,
      )?.stockBatch;
      const reqBat =
        (itm?.batchNumber?.batchId ?? itm?.batchId)
          ? reqStockBatch?.find(
              (bat) =>
                bat?.batchId === (itm?.batchNumber?.batchId ?? itm?.batchId),
            )
          : reqStockBatch?.[0];
      if (reqBat) {
        const unitPrice = itm?.autoConsumed
          ? 0
          : Number(reqBat?.unitSellingPrice ?? 0);
        const taxPercent =
          Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
        // (billDetails?.type === "Pharmacy"
        //   ? clinicDet?.pharmacyTaxId
        //   : clinicDet?.petShopTaxId
        // )?.length > 0
        //   ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
        //   : 0;
        const reqPack = reqBat?.packageUom?.match(/^(\d+)(.+)/);
        const reqPrice = (Number(unitPrice) ?? 0) / Number(reqPack?.[1] ?? 1);
        const reqUnitPrice = itm?.autoConsumed ? 0 : reqBat?.unitSellingPrice;
        const reqPercent = 100 + Number(taxPercent);
        const unitPriceExcludingTax = Number(reqUnitPrice) / (reqPercent / 100);
        const calculatedDiscount =
          discountType === "percentage"
            ? (Number(unitPriceExcludingTax) / 100) * Number(discountValue ?? 0)
            : Number(discountValue ?? 0);
        const priceAfterDiscount =
          Number(unitPriceExcludingTax) - Number(calculatedDiscount);
        const taxValue = (taxPercent / 100) * Number(priceAfterDiscount);
        price = unitPriceExcludingTax;
        discount = Number(calculatedDiscount) * quantity;
        tax = Number(taxValue ?? 0) * quantity;
        total =
          Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
          quantity;
        // }
      }
    } else {
      // Custom items (no stockId and no serviceId)
      price = Number(itm?.price ?? 0);
      const calculatedDiscount =
        discountType === "percentage"
          ? (Number(price) / 100) * Number(discountValue ?? 0)
          : Number(discountValue ?? 0);

      discount = Number(calculatedDiscount) * quantity;
      tax = 0;
      total = (Number(price) - Number(calculatedDiscount)) * quantity;
    }

    return { tax, discount, total, isHigherDiscount };
  };

  const onChangeItemValue = (name, value, addObj) => {
    const reqObj = { ...itemValues, [name]: value };
    if (name === "batchNumber" && addObj) {
      reqObj.batchId = addObj?.batchId;
    }
    if (name === "discountType") {
      reqObj.discountValue = value?.value?.toLowerCase() === "code" ? null : 0;
    }
    setItemValues(reqObj);
  };

  const getBatches = (stkId = null) => {
    if (!stkId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stkId);
    return (
      reqStock?.stockBatch
        //   ?.filter((bat) =>
        //     role === "ROLE_DOCTOR"
        //       ? bat?.locationId === reqFacility()?.primaryStorage ||
        //         bat?.locationId === reqFacility()?.secondaryStorage
        //       : true,
        //   )
        ?.map((bat) => {
          const reqLocation = locationList?.find(
            (loc) => loc?.id === bat?.locationId,
          );
          return {
            name: bat?.batchNo,
            value: bat?.batchId,
            subunits: bat?.subunits,
            quantity: bat?.quantity,
            locationId: bat?.locationId,
            locationName: reqLocation?.locationName ?? "",
            batchId: bat?.batchId,
          };
        })
    );
  };

  const getBatch = (stkId = null, batchId = null) => {
    if (!stkId || !batchId) return null;
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stkId);
    return (
      reqStock?.stockBatch?.find((bat) => bat?.batchId === batchId) ?? null
    );
  };

  const getBillQty = () => {
    return (
      getTabBasedRecords()?.reduce((acc, curr) => acc + curr?.quantity, 0) ?? 0
    );
  };

  const getDiscountCodes = () => {
    const todayDiscounts = getDiscountCodeAvailableToday(
      discountCodes,
      billDetails?.userId ?? null,
      getTaxAndSubTotalAndTotal(getTabBasedRecords())?.subTotal ?? 0,
      // (billDetails?.type === "Pharmacy"
      //   ? getTaxAndSubTotalAndTotal(
      //       getPharmacyRecordBasedType(billDetails?.paymentDetails),
      //     )
      //   : getTaxAndSubTotalAndTotal(
      //       getPetShopRecordBasedType(billDetails?.paymentDetails),
      //     )
      // )?.subTotal ?? 0,
      getBillQty(),
      petBilling?.totalRecords === 1 || !petBilling?.totalRecords,
      getTabBasedRecords()
        // billDetails?.type === "Pharmacy"
        // ? getPharmacyRecordBasedType(billDetails?.paymentDetails)
        // : getPetShopRecordBasedType(billDetails?.paymentDetails)
        ?.some((li) => Number(li?.discount ?? 0) > 0),
      "",
      //   appDet?.pet?.ownershipType ?? null,
    );
    return todayDiscounts?.map((dc) => ({
      name: dc?.discountCode,
      value: dc?.discountCode,
      discountType: dc?.discountType,
      discountValue: dc?.discountValue,
      purchaseType: dc?.purchaseType,
      billingId: dc?.billId,
      limitUsagePerCustomer: dc?.limitUsagePerCustomer,
      limitUsageTotal: dc?.limitUsageTotal,
    }));
  };

  const onDiscountModClose = () => {
    setDisModVsble(false);
    setDisErrs({});
    setDisValues(initDis);
  };

  const onChangeDiscount = (name, value) => {
    const errs = {};
    setDisValues({ ...disValues, [name]: value });
    if (name === "amt") {
      errs.amt =
        value?.length > 0
          ? Number(value) > 0
            ? ""
            : "Value must be positive"
          : "This field is required";
    }
    setDisErrs(errs);
  };

  const handleAddDiscount = (isRemoveDiscount = false) => {
    const errs = {};
    if (disValues?.type === "code") {
      errs.discountCode = disValues?.discountCode?.value
        ? ""
        : "This field is required";
    }
    if (disValues?.type !== "code") {
      errs.amt =
        (disValues?.amt ?? "")?.toString()?.length > 0
          ? Number(disValues?.amt) > 0
            ? ""
            : "Value must be positive"
          : "This field is required";
    }
    if (
      !isRemoveDiscount &&
      ((disValues?.type === "code" && errs?.discountCode?.length > 0) ||
        (disValues?.type !== "code" && errs?.amt?.length > 0))
    ) {
      return setDisErrs(errs);
    }
    const reqDiscountType = isRemoveDiscount
      ? "percentage"
      : disValues?.type?.toLowerCase() === "code"
        ? disValues?.discountCode?.discountType?.toLowerCase()
        : disValues?.type?.toLowerCase();
    const reqDiscountValue = isRemoveDiscount
      ? 0
      : disValues?.type === "code"
        ? disValues?.discountCode?.discountValue
        : disValues?.amt;

    const applyDiscount = getTabBasedRecords()?.map((li) => {
      const reqObj = {
        paymentDetailsId: li?.paymentDetailId,
        discount: 0,
        percentage: reqDiscountType === "percentage" ? "pe" : "pr",
        price: 0,
        mrpPrice: 0,
        mrpDiscount: 0,
        tax: 0,
        total: 0,
        quantity: li?.quantity,
      };
      const reqStck = stocks?.data?.find((stc) => stc?.stockId === li?.stockId);
      const reqBat = reqStck?.stockBatch?.find(
        (btch) => btch?.batchId === li?.batchId,
      );
      if (reqBat) {
        const taxPerent = Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0);
        // (billDetails?.type === "Pharmacy"
        //   ? clinicDet?.pharmacyTaxId
        //   : clinicDet?.petShopTaxId
        // )?.length > 0
        //   ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
        //   : 0;
        const reqPercent = 100 + Number(taxPerent);
        const unitPrice = Number(reqBat?.unitSellingPrice) / (reqPercent / 100);
        const discount =
          reqDiscountType !== "percentage"
            ? Number(
                Number(
                  (Number(unitPrice) /
                    Number(
                      getTaxAndSubTotalAndTotal(getTabBasedRecords())
                        ?.subTotal -
                        // (billDetails?.type === "Pharmacy"
                        //   ? getTaxAndSubTotalAndTotal(
                        //       getPharmacyRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        //   : getTaxAndSubTotalAndTotal(
                        //       getPetShopRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        // )?.subTotal
                        getTaxAndSubTotalAndTotal(getTabBasedRecords())?.tax +
                        // (billDetails?.type === "Pharmacy"
                        //   ? getTaxAndSubTotalAndTotal(
                        //       getPharmacyRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        //   : getTaxAndSubTotalAndTotal(
                        //       getPetShopRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        // )?.tax
                        getTaxAndSubTotalAndTotal(getTabBasedRecords())
                          ?.discount,
                      // (billDetails?.type === "Pharmacy"
                      //   ? getTaxAndSubTotalAndTotal(
                      //       getPharmacyRecordBasedType(
                      //         billDetails?.paymentDetails,
                      //       ),
                      //     )
                      //   : getTaxAndSubTotalAndTotal(
                      //       getPetShopRecordBasedType(
                      //         billDetails?.paymentDetails,
                      //       ),
                      //     )
                      // )?.discount,
                    )) *
                    Number(reqDiscountValue),
                ) * Number(li?.quantity),
              )
            : (Number(
                Number(Number(unitPrice ?? 0) / 100) *
                  Number(reqDiscountValue ?? 0),
              ) ?? 0);
        const priceAfterDiscount = Number(unitPrice) - Number(discount);
        const taxValue = (taxPerent / 100) * Number(priceAfterDiscount);
        reqObj.price = unitPrice;
        reqObj.discount = discount;
        reqObj.tax = Number(taxValue ?? 0) * Number(li?.quantity);
        reqObj.total =
          Number(Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0)) *
          Number(li?.quantity);
        reqObj.mrpPrice = Number(reqBat?.unitSellingPrice);
        reqObj.mrpDiscount = discount;
      }
      if (li?.serviceId) {
        const unitPrice = li?.price;
        const reqServ = services?.data?.find(
          (ser) => ser?.serviceId === li?.serviceId,
        );
        const discount =
          reqDiscountType !== "percentage"
            ? Number(
                Number(
                  Number(unitPrice) /
                    Number(
                      getTaxAndSubTotalAndTotal(getTabBasedRecords())
                        ?.subTotal -
                        // (billDetails?.type === "Pharmacy"
                        //   ? getTaxAndSubTotalAndTotal(
                        //       getPharmacyRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        //   : getTaxAndSubTotalAndTotal(
                        //       getPetShopRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        // )?.subTotal
                        getTaxAndSubTotalAndTotal(getTabBasedRecords())?.tac +
                        // (billDetails?.type === "Pharmacy"
                        //   ? getTaxAndSubTotalAndTotal(
                        //       getPharmacyRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        //   : getTaxAndSubTotalAndTotal(
                        //       getPetShopRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        // )?.tax
                        getTaxAndSubTotalAndTotal(getTabBasedRecords())
                          ?.discount,
                      // (billDetails?.type === "Pharmacy"
                      //   ? getTaxAndSubTotalAndTotal(
                      //       getPharmacyRecordBasedType(
                      //         billDetails?.paymentDetails,
                      //       ),
                      //     )
                      //   : getTaxAndSubTotalAndTotal(
                      //       getPetShopRecordBasedType(
                      //         billDetails?.paymentDetails,
                      //       ),
                      //     )
                      // )?.discount,
                    ),
                ) * Number(reqDiscountValue),
              ) * Number(li?.quantity)
            : (Number(
                Number(Number(unitPrice ?? 0) / 100) *
                  Number(reqDiscountValue ?? 0),
              ) ?? 0);
        reqObj.price = Number(unitPrice ?? 0);
        const taxPerent =
          reqServ?.taxApplicability?.toLowerCase() === "yes"
            ? Number(reqServ?.tax ?? 0)
            : 0;
        const priceAfterDiscount =
          Number(unitPrice ?? 0) - Number(discount ?? 0);
        const taxValue =
          Number(taxPerent / 100) * Number(priceAfterDiscount ?? 0);
        const priceWithTax =
          Number(priceAfterDiscount ?? 0) + Number(taxValue ?? 0);
        reqObj.discount = discount;
        reqObj.total = Number(priceWithTax ?? 0) * Number(li?.quantity);
        reqObj.tax = Number(taxValue ?? 0) * Number(li?.quantity);
        reqObj.mrpPrice = Number(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      if (!li?.serviceId && !li?.stockId) {
        const unitPrice = li?.price;
        const discount =
          (reqDiscountType !== "percentage"
            ? Number(
                Number(
                  Number(
                    Number(unitPrice) /
                      Number(
                        getTaxAndSubTotalAndTotal(getTabBasedRecords())
                          ?.subTotal -
                          // (billDetails?.type === "Pharmacy"
                          //   ? getTaxAndSubTotalAndTotal(
                          //       getPharmacyRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       ),
                          //     )
                          //   : getTaxAndSubTotalAndTotal(
                          //       getPetShopRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       ),
                          //     )
                          // )?.subTotal
                          getTaxAndSubTotalAndTotal(getTabBasedRecords())?.tax +
                          // (billDetails?.type === "Pharmacy"
                          //   ? getTaxAndSubTotalAndTotal(
                          //       getPharmacyRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       ),
                          //     )
                          //   : getTaxAndSubTotalAndTotal(
                          //       getPetShopRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       ),
                          //     )
                          // )?.tax
                          getTaxAndSubTotalAndTotal(getTabBasedRecords())
                            ?.discount,
                        // (billDetails?.type === "Pharmacy"
                        //   ? getTaxAndSubTotalAndTotal(
                        //       getPharmacyRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        //   : getTaxAndSubTotalAndTotal(
                        //       getPetShopRecordBasedType(
                        //         billDetails?.paymentDetails,
                        //       ),
                        //     )
                        // )?.discount,
                      ),
                  ) * Number(reqDiscountValue ?? 0),
                ),
              )
            : (Number(
                Number(Number(unitPrice ?? 0) / 100) *
                  Number(reqDiscountValue ?? 0),
              ) ?? 0)) * Number(li?.quantity);
        reqObj.price = Number(unitPrice ?? 0);
        reqObj.tax = 0;
        reqObj.discount = discount;
        reqObj.total =
          (Number(unitPrice ?? 0) - Number(discount ?? 0)) *
          Number(li?.quantity);
        reqObj.mrpPrice = Number(unitPrice ?? 0);
        reqObj.mrpDiscount = discount;
      }
      return reqObj;
    });
    const data = {
      applyDiscount,
      treatmentDiscountType: billDetails?.treatmentDiscountType ?? "pr",
      treatmentDiscountValue: billDetails?.treatmentDiscountValue ?? 0,
      pharmacyDiscountType:
        billDetails?.type === "Pharmacy"
          ? reqDiscountType === "percentage"
            ? "pe"
            : "pr"
          : (billDetails?.pharmacyDiscountType ?? "pr"),
      pharmacyDiscountValue:
        billDetails?.type === "Pharmacy"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.pharmacyDiscountValue ?? 0),
      petShopDiscountType:
        billDetails?.type === "Pet Shop"
          ? reqDiscountType === "percentage"
            ? "pe"
            : "pr"
          : (billDetails?.petShopDiscountType ?? "pr"),
      petShopDiscountValue:
        billDetails?.type === "Pet Shop"
          ? Number(reqDiscountValue ?? 0)
          : (billDetails?.petShopDiscountValue ?? 0),
    };
    if (disValues?.discountCode?.value) {
      data.billingId = disValues?.discountCode?.billingId;
      data.purchaseType = "oneTime";
      data.pharmacyDiscountId =
        billDetails?.type === "Pharmacy"
          ? uniq([
              ...(billDetails?.pharmacyDiscountId ?? []),
              disValues?.discountCode?.billingId?.toString(),
            ])
          : (billDetails?.pharmacyDiscountId ?? []);
      data.treatmentDiscountId = billDetails?.treatmentDiscountId ?? [];
      data.petShopDiscountId =
        billDetails?.type === "Pet Shop"
          ? uniq([
              ...(billDetails?.petShopDiscountId ?? []),
              disValues?.discountCode?.billingId?.toString(),
            ])
          : (billDetails?.petShopDiscountId ?? []);
    }
    dispatch(
      applyTotalDiscountByPayAndDetailId({
        paymentId: billDetails?.paymentId ?? selectedPayment?.paymentId,
        data,
      }),
    ).then((res) => {
      if (res?.payload) {
        if (disValues?.discountCode?.limitUsageTotal) {
          const reqDis = discountCodes?.find(
            (dc) => dc?.billId === disValues?.discountCode?.billingId,
          );
          const reqObj = {
            discountMethod: reqDis?.discountMethod,
            startDate: !isNaN(Date.parse(reqDis?.startDate))
              ? moment(new Date(reqDis?.startDate)).format("YYYY-MM-DD")
              : null,
            endDate: !isNaN(Date.parse(reqDis?.endDate))
              ? moment(new Date(reqDis?.endDate)).format("YYYY-MM-DD")
              : null,
            discountCode: reqDis?.discountCode,
            discountType: reqDis?.discountType,
            discountValue: reqDis?.discountValue,
            applieTo: reqDis?.applieTo,
            purchaseType: reqDis?.purchaseType,
            categories: reqDis?.categories,
            minRequirementType: reqDis?.minRequirementType,
            minAmount: reqDis?.minAmount,
            minQuantity: reqDis?.minQuantity,
            specificCustomers: reqDis?.specificCustomers,
            limitUsageTotal: reqDis?.limitUsageTotal,
            maxTotalUses: disValues?.discountCode?.limitUsageTotal
              ? (Number(Number(reqDis?.maxTotalUses) - 1) ?? 0)
              : reqDis?.maxTotalUses,
            limitUsagePerCustomer: reqDis?.limitUsagePerCustomer,
            maxPerCustomerUses: disValues?.discountCode?.limitUsagePerCustomer
              ? (Number(Number(reqDis?.maxPerCustomerUses) - 1) ?? 0)
              : reqDis?.maxPerCustomerUses,
            cannotBeCombined: reqDis?.cannotBeCombined,
            isActive: reqDis?.active,
          };
          dispatch(
            updateDiscountCodeById({
              id: disValues?.discountCode?.billingId,
              data: reqObj,
            }),
          );
        }
        handleUpdatePaymentValues();
        onDiscountModClose();
        getDiscountCodeList(
          billDetails?.clinicId !== clinicDet?.id
            ? `?clinicId=${billDetails?.clinicId}`
            : "",
        );
      }
    });
  };

  const tabSourceMap = {
    Treatment: ["clinic", "treatment"],
    Pharmacy: ["pharmacy"],
    "Pet Shop": ["petshop"],
  };

  const getPaymentCollectionsByTab = (collections = null) => {
    const reqList = (
      (collections ? collections : billDetails?.paymentCollections) ?? []
    )?.filter((pc) => {
      const source = (pc?.source ?? "").toLowerCase();
      return tabSourceMap[billDetails?.type]?.includes(source) ?? [];
    });
    return reqList ?? [];
  };

  const getTabBasedCollections = () => {
    const reqSource =
      billDetails?.type === "Treatment"
        ? ["clinic", "treatment"]
        : billDetails?.type === "Pharmacy"
          ? ["pharmacy"]
          : ["petshop"];
    const reqList = (billDetails?.paymentCollections ?? [])
      ?.filter((li) => reqSource.includes((li?.source ?? "")?.toLowerCase()))
      ?.sort((a, b) => {
        const ad = Number(a?.collectionId);
        const bd = Number(b?.collectionId);
        return (Number.isFinite(bd) ? bd : 0) - (Number.isFinite(ad) ? ad : 0);
      });
    return reqList ?? [];
  };

  const onGenerateBill = (notConfirmed = true) => {
    if (
      !billedByValues?.billedBy?.value ||
      (billDetails?.type === "Pharmacy" && !billedByValues?.vet?.value)
    ) {
      const reqObj = {
        ...billedByValues,
        error: !billedByValues?.billedBy?.value ? true : false,
        vetError: !billedByValues?.vet?.value ? true : false,
      };
      return setBilledByValues(reqObj);
    }
    if (notConfirmed) return setGenBillModVsble(true);
    const billedBy = billedByValues?.billedBy;
    const vetVal = billedByValues?.vet;
    const totalTax = Number(
      getTaxAndSubTotalAndTotal(getTabBasedRecords())?.tax,
    );
    const reqUrl =
      billDetails?.type === "Clinic"
        ? `?checkOut=Y&treatmentCheckout=Y&billedById=${billedBy?.value}&billedByName=${billedBy?.name}&totalTax=${totalTax}`
        : billDetails?.type === "Pharmacy"
          ? `?pharmacyCheckout=Y&pharmacyBilledById=${billedBy?.value}&pharmacyBilledByName=${billedBy?.name}&doctorId=${vetVal?.value}&doctorName=${vetVal?.name}&totalTax=${totalTax}`
          : `?petShopCheckout=Y&petShopBilledById=${billedBy?.value}&petShopBilledByName=${billedBy?.name}&totalTax=${totalTax}`;
    dispatch(
      checkoutDirectBilling({
        paymentId: billDetails?.paymentId ?? selectedPayment?.paymentId,
        url: reqUrl,
        // `?treatmentCheckout=Y&pharmacyCheckout=Y&petShopCheckout=Y&billedById=${billedByValues?.billedBy?.value}&billedByName=${billedByValues?.billedBy?.name}&pharmacyBilledById=${billedByValues?.billedBy?.value}&pharmacyBilledByName=${billedByValues?.billedBy?.name}&petShopBilledById=${billedByValues?.billedBy?.value}&petShopBilledByName=${billedByValues?.billedBy?.name}`,
        // &pharmacyCheckout=Y&petShopCheckout=Y
      }),
    ).then((res) => {
      if (res?.payload) {
        setGenBillModVsble(false);
        const prevAmtPaid = Number(amtPaidByTab?.[billDetails?.type] ?? 0);
        const prevTotal = Number(totalByTab?.[billDetails?.type] ?? 0);
        dispatch(
          getBillDetailsByPaymentId(
            billDetails?.paymentId ?? selectedPayment?.paymentId,
          ),
        ).then((res2) => {
          const pay = res2?.payload;
          const payCollects = getPaymentCollectionsByTab(
            pay?.paymentCollections,
          );
          if (prevAmtPaid > prevTotal) {
            const data = [
              {
                mode: getTabBasedCollections()?.[0]?.paymentMode ?? "",
                amount: Number(Number(prevTotal) - Number(prevAmtPaid)),
                tabName: payTabEnum?.[billDetails?.type],
                invoiceNo:
                  (billDetails?.type === "Pharmacy"
                    ? pay?.invoiceNumbers
                    : pay?.petShopInvoiceNumber) ?? "",
              },
            ];
            dispatch(
              payAmountByPaymentId({
                paymentId: billDetails?.paymentId ?? selectedPayment?.paymentId,
                data,
              }),
            ).then((res4) => {
              if (res4?.payload) {
                const form = new FormData();
                form.append("userName", billDetails?.userName);
                if (billDetails?.petName && billDetails?.petId) {
                  form.append("petName", billDetails?.petName);
                  form.append("petId", billDetails?.petId);
                }
                form.append("paymentType", "Collect");
                form.append(
                  "advanceAmount",
                  Number(Math.abs(Number(prevTotal) - Number(prevAmtPaid))),
                );
                form.append(
                  "paymentMode",
                  getTabBasedCollections()?.[0]?.paymentMode ?? "",
                );
                dispatch(
                  updateClinicUserById({
                    userId: billDetails?.userId,
                    form,
                    successMsg: "Payment updated successfully!",
                  }),
                ).then((res5) => {
                  if (res5?.payload) {
                    if (
                      !(Number(amtPaidByTab) > 0 && payCollects?.length > 0)
                    ) {
                      dispatch(
                        getBillDetailsByPaymentId(
                          billDetails?.paymentId ?? selectedPayment?.paymentId,
                        ),
                      );
                    }
                  }
                });
              }
            });
          }
          const amtPaidByTab =
            pay?.type === "Treatment"
              ? (pay?.amtPaid ?? 0)
              : pay?.type === "Pharmacy"
                ? (pay?.pharmacyAmtPaid ?? 0)
                : (pay?.petShopAmtPaid ?? 0);
          if (Number(amtPaidByTab) > 0 && payCollects?.length > 0) {
            const invoiceNoByTab =
              pay?.type === "Treatment"
                ? (pay?.treatmentInvoiceNumber ?? "")
                : pay?.type === "Pharmacy"
                  ? (pay?.invoiceNumbers ?? "")
                  : (pay?.petShopInvoiceNumber ?? "");
            const reqCollctions = payCollects?.map((pc) => ({
              collectionId: pc?.collectionId,
              invoiceNo: invoiceNoByTab,
              status: "APPLIED",
            }));
            dispatch(
              updateMultiCollectionStatusAndInvoiceNo(reqCollctions),
            ).then((res3) => {
              if (res3?.payload) {
                dispatch(
                  getBillDetailsByPaymentId(
                    billDetails?.paymentId ?? selectedPayment?.paymentId,
                  ),
                );
              }
            });
          }
        });
      }
    });
  };

  const payModClose = (typ) => {
    if (typ === "apiSuccess") {
      dispatch(
        getBillDetailsByPaymentId(
          billDetails?.paymentId ?? selectedPayment?.paymentId,
        ),
      );
    }
    setPayModalVisible(false);
  };

  const handlePay = () => {
    setPayModalVisible(true);
  };

  const onDiscardBill = () => {
    setDelModVisible(true);
  };

  const getBilledByList = () => {
    const reqList = (clinicVets ?? [])
      ?.filter((li) => rolesForBilling.includes(li?.userRole))
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
    return reqList;
  };

  const getVetList = () => {
    const reqList = (clinicVets ?? [])
      ?.filter((li) => li?.userRole === "ROLE_DOCTOR")
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
    return reqList;
  };

  const onChangeBilledBy = (name, value, err) => {
    setBilledByValues({
      ...billedByValues,
      [name]: value,
      [err]: value?.value ? false : true,
    });
  };

  const onCollectDeposit = () => {
    setDepositVsble(true);
  };

  const onCollectClose = (typ) => {
    if (typ === "apiSuccess") {
      dispatch(
        getBillDetailsByPaymentId(
          billDetails?.paymentId ?? selectedPayment?.paymentId,
        ),
      );
    }
    setDepositVsble(false);
  };

  const onCloseGenBillMod = () => setGenBillModVsble(false);

  const amtPaidByTab = {
    Treatment: roundWithSignedDiff(billDetails?.amtPaid ?? 0)?.rounded,
    Pharmacy: roundWithSignedDiff(billDetails?.pharmacyAmtPaid ?? 0)?.rounded,
    "Pet Shop": roundWithSignedDiff(billDetails?.petShopAmtPaid ?? 0)?.rounded,
  };
  const totalByTab = {
    Treatment: roundWithSignedDiff(billDetails?.totalAmt ?? 0)?.rounded,
    Pharmacy: roundWithSignedDiff(billDetails?.pharmacyTotalAmt ?? 0)?.rounded,
    "Pet Shop": roundWithSignedDiff(billDetails?.petShopTotalAmt ?? 0)?.rounded,
  };

  const checkoutMap = {
    Clinic: billDetails?.checkOut,
    Treatment: billDetails?.checkOut,
    Pharmacy: billDetails?.pharmacyCheckout,
    "Pet Shop": billDetails?.petShopCheckout,
  };

  const checkStatus = checkoutMap[billDetails?.type];

  const handleSwitchType = () => {
    setSwitchValues({ visible: true, type: billDetails?.type });
  };

  const onChange = (name, value) => {
    setSwitchValues({ ...switchValues, [name]: value });
  };

  const onUpdateType = () => {
    if (!billDetails?.paymentId) return;
    dispatch(
      updatePaymentTypeById({
        paymentId: billDetails?.paymentId,
        url: `?type=${switchValues?.type}`,
      }),
    ).then((res) => {
      if (res?.payload) {
        setSwitchValues({ visible: false });
        dispatch(getBillDetailsByPaymentId(billDetails?.paymentId));
      }
    });
  };

  return (
    <div className="back-white w100Per">
      <div className="scroll-80vh ">
        <div className="light-blue-back3 br5 ph20 pv10">
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14 gray4">
              Date/Time
            </Typography>
            <Typography className="black fs14 font-bold ml5">
              {moment(new Date(billDetails?.createdDate)).format(
                "DD MMM YYYY, HH:mm",
              )}
            </Typography>
            <Typography className="font-medium fs14 gray4 ml20">
              Type
            </Typography>
            <Typography className="black fs14 font-bold ml5">
              POS - {billDetails?.type}
            </Typography>
            <div
              className="flex-row-ali-cen ml10 cursor"
              onClick={handleSwitchType}
            >
              <WifiProtectedSetupIcon sx={w15h15BlueIcon} />
              <Typography className="blue-color fs14 font-bold">
                Switch
              </Typography>
            </div>
          </div>
        </div>
        {/* {billDetails?.checkOut === "P" || billDetails?.checkOut === "Y" ? ( */}
        <div className="light-blue-back3 br5 ph20 pv10">
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14 gray4">
              {checkStatus !== "Y" && checkStatus !== "P"
                ? "Unapplied Credit"
                : "Amount Paid"}
            </Typography>
            <Typography
              className={`${checkStatus !== "Y" && checkStatus !== "P" ? "yellow-color" : "green-color"} fs14 font-bold ml5`}
            >
              Rs{" "}
              {Number(
                billDetails?.type === "Pharmacy"
                  ? Number(billDetails?.pharmacyAmtPaid ?? 0)
                  : Number(billDetails?.petShopAmtPaid ?? 0),
              ) > 0
                ? Number(
                    billDetails?.type === "Pharmacy"
                      ? Number(billDetails?.pharmacyAmtPaid ?? 0)
                      : Number(billDetails?.petShopAmtPaid ?? 0),
                  )?.toFixed(2)
                : Number(
                    billDetails?.type === "Pharmacy"
                      ? Number(billDetails?.pharmacyAmtPaid ?? 0)
                      : Number(billDetails?.petShopAmtPaid ?? 0),
                  )}
            </Typography>
            {checkStatus === "Y" || checkStatus === "P" ? (
              <>
                <Typography className="font-medium fs14 gray4 ml20">
                  Balance Due
                </Typography>
                <Typography className="yellow-color fs14 font-bold ml5">
                  Rs{" "}
                  {Number(
                    Number(
                      roundWithSignedDiff(
                        getTaxAndSubTotalAndTotal(getTabBasedRecords())
                          ?.subTotal,
                      )?.rounded,
                      // billDetails?.type === "Pharmacy"
                      //   ? roundWithSignedDiff(
                      //       getTaxAndSubTotalAndTotal(
                      //         getPharmacyRecordBasedType(
                      //           billDetails?.paymentDetails,
                      //         ),
                      //       )?.subTotal,
                      //     )?.rounded
                      //   : roundWithSignedDiff(
                      //       getTaxAndSubTotalAndTotal(
                      //         getPetShopRecordBasedType(
                      //           billDetails?.paymentDetails,
                      //         ),
                      //       )?.subTotal,
                      //     )?.rounded,
                    ) -
                      Number(
                        billDetails?.type === "Clinic"
                          ? Number(billDetails?.amountpaid ?? 0)
                          : billDetails?.type === "Pharmacy"
                            ? Number(billDetails?.pharmacyAmtPaid ?? 0)
                            : Number(billDetails?.petShopAmtPaid ?? 0),
                      ),
                  )?.toFixed(2)}
                </Typography>
              </>
            ) : null}
            <div className="flex1-end">
              <Typography className="font-medium fs14 gray4 ml20">
                {billDetails?.type}
              </Typography>
              <Typography className="black fs14 font-bold ml5">
                Rs{" "}
                {Number(
                  Number(
                    roundWithSignedDiff(
                      getTaxAndSubTotalAndTotal(
                        getTabBasedRecords(),
                        // billDetails?.type === "Pharmacy"
                        //   ? getPharmacyRecordBasedType(
                        //       billDetails?.paymentDetails,
                        //     )
                        //   : getPetShopRecordBasedType(
                        //       billDetails?.paymentDetails,
                        //     ),
                      )?.subTotal,
                    )?.rounded,
                  ),
                )?.toFixed(2)}
              </Typography>
            </div>
          </div>
        </div>
        {/* ) : null} */}
        <div className="flex-row-ali-cen mv10">
          <Typography className="txt-semi-bold fs14 black ml20">
            Parent Name: {billDetails?.userName}
          </Typography>
          {billDetails?.petName?.length ? (
            <Typography className="txt-semi-bold fs14 black ml15">
              Pet Name: {billDetails?.petName}
            </Typography>
          ) : null}
          <div className="flex1-end">
            <div className="flex-row-ali-cen pr20">
              {checkStatus !== "Y" ? (
                //  &&
                // !billDetails?.invoiceNumbers
                <>
                  {Number(
                    billDetails?.type === "Pharmacy"
                      ? (billDetails?.pharmacyAmtPaid ?? 0)
                      : (billDetails?.petShopAmtPaid ?? 0),
                  ) > 0 ? null : (
                    <>
                      <div className="cursor ml15" onClick={onDiscardBill}>
                        <div className="flex-center">
                          <DeleteOutlineIcon sx={delBtn} />
                        </div>
                        <Typography className="red3 fs8 txt-semi-bold text-align-center">
                          Discard
                        </Typography>
                      </div>
                      <div className="ml15">
                        <CustomButton
                          text="Save As Draft"
                          smallBtn
                          onClick={onSaveAsDraft}
                        />
                      </div>
                    </>
                  )}

                  {/* <div className="ml15">
                    <CustomButton
                      text="Collect Deposit"
                      smallBtn
                      onClick={onCollectDeposit}
                    />
                  </div> */}
                </>
              ) : null}
              {checkStatus !== "Y" && getTabBasedRecords()?.length > 0 ? (
                <div className="ml15">
                  <CustomButton
                    text="Generate Bill"
                    smallBtn
                    onClick={() => onGenerateBill()}
                  />
                </div>
              ) : null}
              {getTabBasedRecords()?.length > 0 ? (
                <div
                  className="cursor ml15"
                  onClick={() => setPrntPrevVsble(true)}
                >
                  <div className="flex-center">
                    <PrintIcon sx={w20h20BlueIcon} />
                  </div>
                  <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                    Print
                  </Typography>
                </div>
              ) : null}
              {/* {billDetails?.checkOut === "P" ||
              billDetails?.checkOut === "Y" ? ( */}
              {getTabBasedRecords()?.length > 0 ? (
                <div className="cursor ml15" onClick={handlePay}>
                  <div className="flex-center">
                    <AccountBalanceWalletIcon sx={w20h20GreenIcon} />
                  </div>
                  <Typography className="green4 fs8 txt-semi-bold text-align-center">
                    Pay
                  </Typography>
                </div>
              ) : null}
              {/* ) : null} */}
            </div>
          </div>
        </div>

        <Container maxWidth="xl">
          <Box className="pb20 mt10 mh20Min">
            <TableContainer sx={{ maxHeight: 250 }}>
              <Table
                sx={{ minWidth: 200 }}
                aria-labelledby="tableTitle"
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    {phrTblHdrs?.map((hl, i) => (
                      <TableCell
                        key={i}
                        style={tblGrayBack}
                        sortDirection={false}
                        className={`table-header-text`}
                      >
                        <div
                          style={{
                            width:
                              hl === "serviceitemname"
                                ? 250
                                : hl === "discount"
                                  ? 100
                                  : hl === "qty" ||
                                      hl === "unitPrice" ||
                                      hl === "tax"
                                    ? 80
                                    : "auto",
                          }}
                        >
                          {tableNameExpan?.[hl]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getTabBasedRecords()?.length > 0 &&
                    getTabBasedRecords()
                      ?.filter((pd) => pd?.type !== "consultation")
                      ?.map((bil) => {
                        let reqTax =
                          selectedItem?.paymentDetailId === bil?.paymentDetailId
                            ? Number(
                                (Number(
                                  itemValues?.mrpPrice ??
                                    itemValues?.price ??
                                    0,
                                ) /
                                  100) *
                                  Number(itemValues?.tax ?? 0) *
                                  Number(itemValues?.quantity),
                              )?.toFixed(2)
                            : bil?.tax;

                        const reqTotal = bil?.total;
                        const isProcedureSubItem =
                          (bil?.procedureId ?? "")?.toString()?.length > 0 &&
                          // bil?.patientWorkbook &&
                          !bil?.mainProcedure &&
                          bil?.linked !== "N";
                        const reqObj = {
                          ...bil,
                          isProcedureSubItem,
                          serviceitemname: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >
                              {bil?.tradeName ?? bil?.name ?? ""}
                            </div>
                          ),
                          qty: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >
                              {`${bil?.quantity}${
                                bil?.stockId && bil?.packageUom?.length > 0
                                  ? getRightPackageUom(bil?.packageUom, true)
                                  : ""
                              }`}
                            </div>
                          ),
                          unitPrice: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >{`Rs ${
                              Number(bil?.mrpPrice ?? bil?.price) > 0
                                ? Number(bil?.mrpPrice ?? bil?.price).toFixed(2)
                                : Number(bil?.mrpPrice ?? bil?.price)
                            }`}</div>
                          ),
                          discount:
                            Number(bil?.mrpDiscount ?? bil?.discount) > 0 ? (
                              <div
                                className={`fs12 font-bold ${
                                  isProcedureSubItem ? "green2" : "black"
                                }`}
                              >{`Rs ${Number(
                                bil?.mrpDiscount ?? bil?.discount,
                              ).toFixed(2)}`}</div>
                            ) : (
                              "-"
                            ),
                          total: (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >{`Rs ${Number(bil?.reqTotal).toFixed(2)}`}</div>
                          ),
                          days: bil?.days ?? "-",
                          variantId: bil?.variantId ?? null,
                          serviceId: bil?.serviceId ?? null,
                        };
                        if (
                          billDetails?.checkOut !== "P" &&
                          billDetails?.checkOut !== "Y" &&
                          billDetails?.pharmacyCheckout !== "Y" &&
                          billDetails?.petShopCheckout !== "Y"
                        ) {
                          reqObj.pay = (
                            <div className="flex-row">
                              <div
                                className="cursor"
                                onClick={() => handleDelete(bil)}
                              >
                                <div className="flex-center">
                                  <DeleteOutlineIcon sx={delBtn} />
                                </div>
                                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                  Delete
                                </Typography>
                              </div>
                              <div
                                className="cursor ml15"
                                onClick={() => handleEdit(bil)}
                              >
                                <div className="flex-center">
                                  <EditIcon sx={w20h20BlueIcon} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  Edit
                                </Typography>
                              </div>
                            </div>
                          );
                        }
                        reqObj.reqTotal =
                          selectedItem?.paymentDetailId ===
                            bil?.paymentDetailId && editVisible
                            ? Number(reqTotal)
                            : (reqTotal ?? bil?.total);
                        reqObj.productId = itemValues?.productId;
                        reqObj.tax =
                          // clinicDet?.pharmacyTaxId?.length > 0 ? (
                          reqTax > 0 ? (
                            <div
                              className={`fs12 font-bold ${
                                isProcedureSubItem ? "green2" : "black"
                              }`}
                            >{`Rs ${Number(reqTax).toFixed(2)}`}</div>
                          ) : (
                            "-"
                          );
                        // ) : (
                        //   "-"
                        // );
                        return reqObj;
                      })
                      ?.map((bil, ind) => {
                        const reqList = bil?.reqList;
                        return (
                          <>
                            <TableRow tabIndex={-1} key={ind}>
                              {phrTblHdrs?.map((th, index) => {
                                return (
                                  <TableCell
                                    key={index + th + "tr"}
                                    component="th"
                                    className="table-text-black capitalize"
                                  >
                                    <div
                                      className="upload-row"
                                      style={{
                                        width:
                                          th === "serviceitemname"
                                            ? 250
                                            : th === "discount"
                                              ? 100
                                              : th === "qty" ||
                                                  th === "unitPrice" ||
                                                  th === "tax"
                                                ? 80
                                                : "auto",
                                      }}
                                    >
                                      <div>
                                        {th === "serviceitemname" ? (
                                          <div>
                                            {bil?.[th]}
                                            {bil?.stockId && (
                                              <div>
                                                <div className="fs10 gray4 font-medium">
                                                  Generic Name:{" "}
                                                  {bil?.name ?? ""}
                                                </div>
                                                <div className="fs10 gray4 font-medium">
                                                  Batch No.:{" "}
                                                  {bil?.batchNo ?? ""} Expiry:{" "}
                                                  {bil?.expiryDate?.length > 0
                                                    ? moment(
                                                        new Date(
                                                          bil?.expiryDate,
                                                        ),
                                                      )?.format("DD MMM YYYY")
                                                    : ""}
                                                </div>
                                                {bil?.drugSchedule?.length >
                                                0 ? (
                                                  <div className="fs10 gray4 font-medium">
                                                    Drug Schedule:{" "}
                                                    {bil?.drugSchedule ?? ""}
                                                  </div>
                                                ) : null}
                                              </div>
                                            )}
                                          </div>
                                        ) : th === "total" ? (
                                          <div
                                            className={`fs12 font-bold ${
                                              bil?.isProcedureSubItem
                                                ? "green2"
                                                : "black"
                                            }`}
                                          >{`Rs ${Number(bil?.reqTotal).toFixed(
                                            2,
                                          )}`}</div>
                                        ) : typeof bil?.[th] === "number" ? (
                                          Number(bil?.[th]).toFixed(2)
                                        ) : (
                                          bil?.[th]
                                        )}
                                      </div>
                                    </div>
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          </>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Container>
        {searchVisible ? (
          <div className="mh20">
            <div className="ph10">
              <CustomTextField
                placeholder="Search"
                fullWidth
                handleChange={(e) => setSearchValue(e?.target?.value)}
                value={searchValue}
              />
            </div>
            {searchValue?.length > 0 ? (
              <div className="br8brblack pv10 ph10 mt10">
                <div className="flex-row mv5">
                  <div className="w25Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Name
                    </Typography>
                  </div>
                  <div className="w10Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Type
                    </Typography>
                  </div>
                  <div className="w15Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Available Qty
                    </Typography>
                  </div>
                  <div className="w20Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Category
                    </Typography>
                  </div>
                  <div className="w20Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Price
                    </Typography>
                  </div>
                  <div className="w10Per">
                    <Typography className="txt-regular fs14 blue-color">
                      Status
                    </Typography>
                  </div>
                </div>
                {getFilteredList()?.length > 0 ? (
                  <div className="scroll-100px">
                    {getFilteredList()?.map((fil, i) => {
                      const reqStatus = (() => {
                        if (fil?.serviceId) return null;
                        const expiryDate = fil?.stockBatch?.[0]?.expiryDate;
                        if (!expiryDate?.length) return null;
                        const today = moment().startOf("day");
                        const expiry = moment(new Date(expiryDate)).startOf(
                          "day",
                        );
                        if (expiry.isBefore(today)) return "expired";
                        if (expiry.diff(today, "days") < 30) {
                          return "nearExpiry";
                        }
                        return null;
                      })();
                      return (
                        <div
                          className="bill-itm cursor"
                          key={i + "fil"}
                          onClick={() => handleAddItem(fil)}
                        >
                          <div className="w25Per">
                            <Typography className="txt-regular fs14">
                              {fil?.name}
                            </Typography>
                          </div>
                          <div className="w10Per">
                            <Typography className="txt-regular fs14">
                              {fil?.type}
                            </Typography>
                          </div>
                          <div className="w15Per">
                            <Typography className="txt-regular fs14">
                              {fil?.availableQty}
                            </Typography>
                          </div>
                          <div className="w20Per">
                            <Typography className="txt-regular fs14">
                              {fil?.category}
                            </Typography>
                          </div>
                          <div className="w20Per">
                            <Typography className="txt-regular fs14">
                              {(fil?.servicePrice ??
                              fil?.stockBatch?.[0]?.unitSellingPrice)
                                ? `Rs ${Number(
                                    fil?.servicePrice ??
                                      fil?.stockBatch?.[0]?.unitSellingPrice,
                                  ).toFixed(2)}`
                                : "-"}
                            </Typography>
                          </div>
                          <div className="w10Per">
                            {reqStatus ? (
                              <div
                                className={`con-fit fs12 white-color ph10 pv2 br5 ${
                                  reqStatus === "expired"
                                    ? "card-bot-red-back"
                                    : "card-top-yellow-color"
                                }`}
                              >
                                {reqStatus === "expired"
                                  ? "Expired"
                                  : "Near Expiry"}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="flex-center mt20">
                    <Typography className="txt-regular">
                      No records available
                    </Typography>
                  </div>
                )}

                {getFilteredList()?.length > 0 ? null : (
                  <div className="flex-row flex-center">
                    <div className="flex-start">
                      <Typography className="fs14">{searchValue}</Typography>
                    </div>
                    <div className="flex1-end mt20">
                      <div className="w15Per">
                        <CustomButton
                          text="Add New"
                          smallBtn
                          onClick={() => handleAddItem()}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        ) : null}
        {billDetails?.checkOut !== "Y" &&
        billDetails?.checkOut !== "Y" &&
        billDetails?.pharmacyCheckout !== "Y" &&
        billDetails?.pharmacyCheckout !== "P" &&
        billDetails?.petShopCheckout !== "Y" &&
        billDetails?.petShopCheckout !== "P" ? (
          <div className="flex-row mt20">
            <div>
              <div className="flex-row ph10">
                <div>
                  <CustomButton
                    text="Add"
                    smallBtn
                    onClick={() => setSearchVisible(true)}
                  />
                </div>
                <div className="ml15">
                  <CustomButton
                    text={`${
                      Number(
                        (billDetails?.type === "Pharmacy"
                          ? billDetails?.pharmacyDiscountValue
                          : billDetails?.petShopDiscountValue) ?? 0,
                      ) > 0
                        ? "Edit"
                        : "Apply"
                    } Discount`}
                    smallBtn
                    onClick={handleApplyDiscount}
                  />
                </div>
              </div>

              {billDetails?.checkOut !== "P" &&
              billDetails?.checkOut !== "Y" &&
              // billDetails?.type === "Pharmacy"
              // ? getPharmacyRecordBasedType(billDetails?.paymentDetails)
              // : getPetShopRecordBasedType(billDetails?.paymentDetails)
              getTabBasedRecords()?.length > 0 ? (
                <div className="flex-row ph10 mt20">
                  {billDetails?.type === "Pharmacy" ? (
                    <div className="w200Px">
                      <CustomSelect
                        list={getVetList()}
                        value={billedByValues?.vet ?? null}
                        search
                        label="Vet Name"
                        handleChange={(e, value) => {
                          onChangeBilledBy("vet", value, "vetError");
                        }}
                        error={billedByValues?.vetError ?? false}
                        helperText={
                          billedByValues?.vetError
                            ? "This field is required"
                            : ""
                        }
                      />
                    </div>
                  ) : null}
                  <div
                    className={`w200Px ${billDetails?.type === "Pharmacy" ? "ml15" : ""}`}
                  >
                    <CustomSelect
                      list={getBilledByList()}
                      value={billedByValues?.billedBy ?? null}
                      search
                      label="Billed By"
                      handleChange={(e, value) => {
                        onChangeBilledBy("billedBy", value, "error");
                      }}
                      error={billedByValues?.error ?? false}
                      helperText={
                        billedByValues?.error ? "This field is required" : ""
                      }
                    />
                  </div>
                </div>
              ) : null}
            </div>

            <div className="flex1-end ph20 mtMin5">
              <div className="w100Per flex-column">
                <div className="flex1-end">
                  <div className="w40Per">
                    <div className="flex-row-between-align-center">
                      <div className="fs14 txt-regular">Discount</div>
                      <div className="fs14 txt-regular">
                        {Number(
                          getTaxAndSubTotalAndTotal(getTabBasedRecords())
                            ?.discount,
                          // (billDetails?.type === "Pharmacy"
                          //   ? getTaxAndSubTotalAndTotal(
                          //       getPharmacyRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       ),
                          //     )
                          //   : getTaxAndSubTotalAndTotal(
                          //       getPetShopRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       ),
                          //     )
                          // )?.discount,
                        ) > 0
                          ? `Rs ${Number(
                              getTaxAndSubTotalAndTotal(getTabBasedRecords())
                                ?.discount,
                              // (billDetails?.type === "Pharmacy"
                              //   ? getTaxAndSubTotalAndTotal(
                              //       getPharmacyRecordBasedType(
                              //         billDetails?.paymentDetails,
                              //       ),
                              //     )
                              //   : getTaxAndSubTotalAndTotal(
                              //       getPetShopRecordBasedType(
                              //         billDetails?.paymentDetails,
                              //       ),
                              //     )
                              // )?.discount,
                            )?.toFixed(2)}`
                          : "-"}
                      </div>
                    </div>
                    <div className="flex-row-between-align-center">
                      <div className="fs14 txt-regular">
                        {/* {billDetails?.type === "Pet Shop"
                        ? "Pet Shop"
                        : "Pharmacy"}{" "} */}
                        Subtotal
                      </div>
                      <div className="fs14 txt-regular">
                        Rs{" "}
                        {Number(
                          Number(
                            getTaxAndSubTotalAndTotal(getTabBasedRecords())
                              ?.subTotalNew,
                            // getTaxAndSubTotalAndTotal(
                            //   billDetails?.type === "Pet Shop"
                            //     ? getPetShopRecordBasedType(
                            //         billDetails?.paymentDetails,
                            //       )
                            //     : getPharmacyRecordBasedType(
                            //         billDetails?.paymentDetails,
                            //       ),
                            // )?.subTotalNew,
                          ),
                        )?.toFixed(2)}
                      </div>
                    </div>
                    <div className="flex-row-between-align-center">
                      <div className="fs14 txt-regular">Taxes (CGST) </div>
                      <div className="fs14 txt-regular">
                        {Number(
                          getTaxAndSubTotalAndTotal(getTabBasedRecords())?.tax,
                          // getTaxAndSubTotalAndTotal(
                          //   billDetails?.type === "Pharmacy"
                          //     ? getPharmacyRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       )
                          //     : getTreatmentRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       ),
                          // )?.tax,
                        ) /
                          2 >
                        0
                          ? `Rs ${Number(
                              Number(
                                getTaxAndSubTotalAndTotal(getTabBasedRecords())
                                  ?.tax,
                                // getTaxAndSubTotalAndTotal(
                                //   billDetails?.type === "Pharmacy"
                                //     ? getPharmacyRecordBasedType(
                                //         billDetails?.paymentDetails,
                                //       )
                                //     : getTreatmentRecordBasedType(
                                //         billDetails?.paymentDetails,
                                //       ),
                                // )?.tax,
                              ) / 2,
                            )?.toFixed(2)}`
                          : "-"}
                      </div>
                    </div>
                    <div className="flex-row-between-align-center">
                      <div className="fs14 txt-regular">Taxes (SGST) </div>
                      <div className="fs14 txt-regular">
                        {Number(
                          getTaxAndSubTotalAndTotal(getTabBasedRecords())?.tax,
                          // getTaxAndSubTotalAndTotal(
                          //   billDetails?.type === "Pharmacy"
                          //     ? getPharmacyRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       )
                          //     : getTreatmentRecordBasedType(
                          //         billDetails?.paymentDetails,
                          //       ),
                          // )?.tax,
                        ) /
                          2 >
                        0
                          ? `Rs ${Number(
                              Number(
                                getTaxAndSubTotalAndTotal(getTabBasedRecords())
                                  ?.tax,
                                // getTaxAndSubTotalAndTotal(
                                //   billDetails?.type === "Pharmacy"
                                //     ? getPharmacyRecordBasedType(
                                //         billDetails?.paymentDetails,
                                //       )
                                //     : getTreatmentRecordBasedType(
                                //         billDetails?.paymentDetails,
                                //       ),
                                // )?.tax,
                              ) / 2,
                            )?.toFixed(2)}`
                          : "-"}
                      </div>
                    </div>
                    <div className="flex-row-between-align-center">
                      <div className="fs14 txt-regular">Round Off</div>
                      <div className="fs14 txt-regular">
                        Rs{" "}
                        {
                          roundWithSignedDiff(
                            Number(
                              getTaxAndSubTotalAndTotal(getTabBasedRecords())
                                ?.subTotal,
                              // getTaxAndSubTotalAndTotal(
                              //   billDetails?.type === "Pet Shop"
                              //     ? getPetShopRecordBasedType(
                              //         billDetails?.paymentDetails,
                              //       )
                              //     : getPharmacyRecordBasedType(
                              //         billDetails?.paymentDetails,
                              //       ),
                              // )?.subTotal,
                            ),
                          )?.difference
                        }
                      </div>
                    </div>
                    <div className="flex-row-between-align-center">
                      <div className="txt-semi-bold fs14 blue-color">
                        {/* {billDetails?.type === "Pet Shop"
                        ? "Pet Shop"
                        : "Pharmacy"}{" "} */}
                        Total
                      </div>
                      <div className="txt-semi-bold fs14 blue-color">
                        Rs{" "}
                        {roundWithSignedDiff(
                          Number(
                            getTaxAndSubTotalAndTotal(getTabBasedRecords())
                              ?.subTotal,
                            // getTaxAndSubTotalAndTotal(
                            //   billDetails?.type === "Pet Shop"
                            //     ? getPetShopRecordBasedType(
                            //         billDetails?.paymentDetails,
                            //       )
                            //     : getPharmacyRecordBasedType(
                            //         billDetails?.paymentDetails,
                            //       ),
                            // )?.subTotal,
                          ),
                        )?.rounded?.toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {prntPrevVsble ? (
        <BillingPreview
          selectedBill={billDetails}
          modVsble={prntPrevVsble}
          onClosePreview={() => {
            setPrntPrevVsble(false);
          }}
          billsToShow={[
            billDetails?.type === "Clinic"
              ? "treatment"
              : billDetails?.type === "Pharmacy"
                ? "pharmacy"
                : "petshop",
          ]}
        />
      ) : null}
      {payModalVisible ? (
        <CommonPayModal
          modVsble={payModalVisible}
          selectedBill={billDetails}
          billsToShow={["TREATMENT", "PHARMACY", "PETSHOP"]}
          onCloseMod={payModClose}
          selectedTab={payTabEnum?.[billDetails?.type]}
        />
      ) : null}
      {depositVsble ? (
        <CollectDeposit
          modVsble={depositVsble}
          payment={billDetails}
          onCloseMod={onCollectClose}
          tab={billingTabEnum?.[billDetails?.type]}
        />
      ) : null}
      <CustomModal
        open={switchValues?.visible}
        onClose={() => onChange("visible", false)}
        header="Swich"
        modal
        modalWidth={20}
        headerBold
        headerShown={false}
      >
        <div className="ph10">
          <Typography className="fs16 font-bold blue-color flex-center">
            Switch
          </Typography>
          <div className="font-medium fs14 black2">Bill as</div>
          <CustomSelect
            list={billAsForBillingHistory}
            value={switchValues?.type}
            handleChange={(e) => onChange("type", e?.target?.value)}
            select
          />
          <div className="flex-row flex-center mv15">
            <div>
              <CustomButton text="Update" smallBtn onClick={onUpdateType} />
            </div>
            <div className="ml15">
              <CustomButton
                text="Cancel"
                smallBtn
                redBtn
                onClick={() => onChange("visible", false)}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={genBillModVsble}
        onClose={onCloseGenBillMod}
        header="Close Bill"
        modal
        modalWidth={35}
        headerBold
      >
        <div className="mh20 mb30">
          <div className="txt-semi-bold fs16">
            Are you sure you want to close this bill?
          </div>
          <div className="fs14 font-medium">
            No further changes will be allowed after this step.
          </div>
          <div className="fs14 txt-semi-bold mt20">Payment Summary:</div>
          {Number(amtPaidByTab?.[billDetails?.type] ?? 0) <
          Number(totalByTab?.[billDetails?.type] ?? 0) ? (
            <>
              <div className="fs14 font-medium">
                Unapplied credit to be used:{" "}
                {Number(amtPaidByTab?.[billDetails?.type]) > 0
                  ? Number(amtPaidByTab?.[billDetails?.type])?.toFixed(2)
                  : amtPaidByTab?.[billDetails?.type]}
              </div>
              <div className="fs14 font-medium">
                Remaining balance due:{" "}
                {Number(
                  Number(totalByTab?.[billDetails?.type] ?? 0) -
                    Number(amtPaidByTab?.[billDetails?.type] ?? 0),
                )?.toFixed(2)}
              </div>
            </>
          ) : Number(amtPaidByTab?.[billDetails?.type] ?? 0) ===
            Number(totalByTab?.[billDetails?.type] ?? 0) ? (
            <>
              <div className="fs14 font-medium">
                Full invoice total will be settled using available credit of:{" "}
                {Number(amtPaidByTab?.[billDetails?.type])?.toFixed(2)}
              </div>
            </>
          ) : Number(amtPaidByTab?.[billDetails?.type] ?? 0) >
            Number(totalByTab?.[billDetails?.type] ?? 0) ? (
            <>
              <div className="fs14 font-medium">
                Unapplied credit to be used:{" "}
                {Number(totalByTab?.[billDetails?.type])?.toFixed(2)}
              </div>
              <div className="fs14 font-medium">Remaining balance due: 0</div>
              <div className="fs14 font-medium red-color">
                Excess of{" "}
                {Number(
                  Number(amtPaidByTab?.[billDetails?.type] ?? 0) -
                    Number(totalByTab?.[billDetails?.type] ?? 0),
                )?.toFixed(2)}{" "}
                will be moved to customer credits.
              </div>
            </>
          ) : null}
          {/* <div className="flex-center fs14 font-medium">
                   Please confirm to proceed.
                 </div> */}
          <div className="flex-row-ali-cen flex-center mt20">
            <div>
              <CustomButton
                text="Confirm"
                redBtn
                smallBtn
                onClick={() => onGenerateBill(false)}
              />
            </div>
            <div className="ml20">
              <CustomButton
                text="Cancel"
                smallBtn
                onClick={onCloseGenBillMod}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          {`Are you sure you want to ${selectedItem?.paymentDetailId ? "delete" : "discard"} the ${selectedItem?.paymentDetailId ? "item" : "payment"}?`}
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleDelConfirm}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={editModVsble}
        onClose={onCloseEditMod}
        header="Edit"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-90vh ph10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold fs14 gray4">
                Sevice / Item Name
              </Typography>
              <CustomTextField
                value={itemValues?.name}
                handleChange={(e) =>
                  onChangeItemValue("name", e?.target?.value)
                }
                fullWidth
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">Quantity</Typography>
              <CustomTextField
                value={itemValues?.quantity}
                handleChange={(e) =>
                  onChangeItemValue("quantity", e?.target?.value)
                }
                fullWidth
                type="number"
                suffix={
                  itemValues?.stockId ? (
                    getRightPackageUom(
                      getBatch(
                        itemValues?.stockId,
                        itemValues?.batchNumber?.batchId ?? itemValues?.batchId,
                      )?.salesUom,
                      true,
                    )?.length > 0 ? (
                      <Custom3dotString
                        str={`${getRightPackageUom(
                          getBatch(
                            itemValues?.stockId,
                            itemValues?.batchNumber?.batchId ??
                              itemValues?.batchId,
                          )?.salesUom,
                          true,
                        )}`}
                        length={9}
                        className="fs12 font-medium"
                        capitalize={false}
                      />
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">
                Unit Price
              </Typography>
              <CustomTextField
                value={itemValues?.price}
                handleChange={(e) =>
                  onChangeItemValue("price", e?.target?.value)
                }
                fullWidth
                type="number"
                disabled={
                  !itemValues?.batchId &&
                  !itemValues?.stockId &&
                  !itemValues?.productId
                    ? false
                    : true
                }
              />
            </Grid>
            {itemValues?.stockId ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs14 gray4">
                  Batch Number
                </Typography>
                <CustomSelect
                  list={getBatches(itemValues?.stockId)}
                  value={itemValues?.batchNumber}
                  handleChange={(e, value) => {
                    onChangeItemValue("batchNumber", value);
                  }}
                  search
                  isBatchNumber
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">
                Unit Discount
              </Typography>
              {itemValues?.discountType?.value === "code" ? (
                <CustomSelect
                  list={getDiscountCodes()}
                  name="discountValue"
                  value={itemValues?.discountValue}
                  handleChange={(e, value) =>
                    onChangeItemValue("discountValue", value)
                  }
                  search
                  error={getTaxDiscountAndTotal(itemValues)?.isHigherDiscount}
                  helperText={
                    getTaxDiscountAndTotal(itemValues)?.isHigherDiscount
                      ? "Discount cannot be greater than unit price"
                      : ""
                  }
                />
              ) : (
                <CustomTextField
                  name="discountValue"
                  fullWidth
                  handleChange={(e) =>
                    onChangeItemValue("discountValue", e?.target?.value)
                  }
                  value={itemValues?.discountValue}
                  type="number"
                  error={getTaxDiscountAndTotal(itemValues)?.isHigherDiscount}
                  helperText={
                    getTaxDiscountAndTotal(itemValues)?.isHigherDiscount
                      ? "Discount cannot be greater than unit price"
                      : ""
                  }
                  mandatoryField
                />
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Typography className="font-bold fs14 gray4">
                Discount Type
              </Typography>
              <CustomSelect
                list={dropDiscountTypes}
                value={itemValues?.discountType}
                handleChange={(e, value) => {
                  onChangeItemValue("discountType", value);
                }}
                search
              />
            </Grid>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 gray17">
                Discount
              </Typography>
              <Typography className="txt-semi-bold fs14 gray17 pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.discount) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.discount,
                    ).toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 gray17">Tax</Typography>
              <Typography className="txt-semi-bold fs14 gray17 pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.tax) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.tax,
                    ).toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
            <div className="flex-row-between-align-center pl20 w100Per mt15">
              <Typography className="txt-semi-bold fs14 blue-color">
                Item Total
              </Typography>
              <Typography className="txt-semi-bold fs14 blue-color pr20">
                {Number(getTaxDiscountAndTotal(itemValues)?.total) > 0
                  ? `Rs. ${Number(
                      getTaxDiscountAndTotal(itemValues)?.total,
                    )?.toFixed(2)}`
                  : "-"}
              </Typography>
            </div>
          </Grid>
          <div className="flex1-center mv20">
            <div>
              <CustomButton
                text="Update"
                smallBtn
                onClick={() => handleUpdateItem(itemValues)}
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={disModVsble}
        onClose={onDiscountModClose}
        header="Apply Discount"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={0.5} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 selectypetext ">
              Discount Type
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomCheckbox
              radio
              onChange={(e) => onChangeDiscount("type", e?.target?.value)}
              radios={radioDiscountTypes}
              defaultValue={disValues?.type}
            />
          </Grid>
          {disValues?.type === "code" ? (
            <CustomSelect
              list={getDiscountCodes()}
              name="discountCode"
              value={disValues?.discountCode}
              handleChange={(e, value) =>
                onChangeDiscount("discountCode", value)
              }
              search
              error={!!disErrs?.discountCode}
              helperText={disErrs?.discountCode}
            />
          ) : (
            <CustomTextField
              label={`Discount  ${
                disValues?.type?.toLowerCase() === "price"
                  ? "Price"
                  : "Percentage"
              }`}
              name="amt"
              fullWidth
              handleChange={(e) => onChangeDiscount("amt", e?.target?.value)}
              value={disValues?.amt}
              labelTop
              type="number"
              error={!!disErrs?.amt}
              helperText={disErrs?.amt}
              mandatoryField
            />
          )}
          {((billDetails?.type === "Pharmacy"
            ? billDetails?.pharmacyDiscountValue
            : billDetails?.petShopDiscountValue) ?? 0) > 0 ? (
            <div
              className="flex-row-ali-cen cursor"
              onClick={() => handleAddDiscount(true)}
            >
              <Typography className="font-medium fs14 red-color mr5">
                Remove Discount
              </Typography>
              <CloseIcon
                sx={{
                  color: AppColors.red,
                  width: 15,
                  height: 15,
                  stroke: AppColors.red,
                  strokeWidth: 2,
                }}
              />
            </div>
          ) : null}
          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Add"
                onClick={() => handleAddDiscount(false)}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </div>
  );
};

export default PointOfSaleNew;
